import * as md5 from 'md5';
import React, { Component, Fragment } from 'react';
import { Button, Col, Input, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AdminTable from './components/AdminTable.js';
import BatchUploader from './components/BatchUploader.js';
import BuildingModal from './components/BuildingModal.js';
import CreateModal from './components/CreateModal.js';
import EditTable from './components/EditTable.js';
import PMFViewer from './components/PMFViewer.js';
import ErrorHolder from './components/ErrorHolder.js';
import FormCurrency from './components/FormCurrency.js';
import FormText from './components/FormText.js';
import FormTextArea from './components/FormTextArea.js';
import FormSelect from './components/FormSelect.js';
import FormBool from './components/FormBool.js';
import FormDatePicker from './components/FormDatePicker.js';
import Header from './components/Header.js';
import ProjectForm from './components/ProjectForm.js';
import ProgramForm from './components/ProgramForm.js';
import ComboLabel from './components/ComboLabel.js';
import ProgramCombo from './components/ProgramCombo.js';
import QuestionField from './components/QuestionField.js';
import ComboInput from './components/ComboInput.js';
import TabNavs from './components/TabNavs.js';
import POForm from './components/POForm.js';
import FormSection from './components/FormSection.js';
import ServiceCallForm from './components/ServiceCallForm.js';
import QuoteRecordSelector from './components/QuoteRecordSelector.js';
import FormNumber from './components/FormNumber.js';
import Touchy from './images/touchyloader.gif';
import WebLink from './images/webLink.png';
import Delete from './images/deleteRecord.png';
import moment from 'moment-timezone';
import './App.css';

const API_PREFIX = process.env.REACT_APP_API_PREFIX;
const BARBARIAN_PREFIX = process.env.REACT_APP_BARBARIAN_PREFIX;
const FORM_PREFIX = process.env.REACT_APP_FORM_PREFIX;
const MOD_QUOTE_PREFIX = process.env.REACT_APP_MOD_QUOTE_PREFIX;
const PORTAL_PREFIX = process.env.REACT_APP_PORTAL_PREFIX;
const REPORT_PREFIX = process.env.REACT_APP_REPORT_PREFIX;
const SERVICE_QUOTE_PREFIX = process.env.REACT_APP_SERVICE_QUOTE_PREFIX;
const ROLLER_PREFIX = process.env.REACT_APP_ROLLER_PREFIX;
const SESSION_KEY = process.env.REACT_APP_SESSION_KEY;

/*
* Structure is as follows:
* Constructor.
* Basic Functionality.
* Write Data Functionality.
* Render Function.
* All form building stuff (1k+ lines of case statements).
*/

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeMod: 'test',
			activeModType: 'test',
			activeSvc: 'test',
			activeSvcType: 'test',
			adminData: {},
			adminOriginal: '',
			buildingModalShow: false,
			comboFocus: 'COMPANIES',
			createModalSection: 'NEW_PROJ',
			createModalSubsection: 'MAIN',
			createModalShow: false,
			dbData: {},
			dbView: false,
			dupTarget: false,
			dupTargetType: false,
			error: '',
			formChanged: false,
			fuzzyFindValue: '',
			headerDropDown: false,
			loading: false,
			modRecords: [],
			origData: '',
			propNums: [],
			route: '',
			routeHolder: '',
			searchResults: [],
			section: 'SPLASH',
			showBldgBatch: false,
			showPCBatch: false,
			showMonitorBatch: false,
			showHardwareDuplication: false,
			subsection: 'MAIN',
			serviceRecords: [],
			theme: 0,
			themeName: 'LIGHT',
			emailFilter: '',
			propFilter: '',
			programForm: <div />,
			projectForm: <div />,
			hardwareForm: <div />,
			permissionGroups: [],
			uploadProgress: ''
		};

		this.adminWrite = this.adminWrite.bind(this);
		this.adminUpdate = this.adminUpdate.bind(this);
		this.areEqual = this.areEqual.bind(this);
		this.arrayDiscrepencyCheck = this.arrayDiscrepencyCheck.bind(this);
		this.batchReset = this.batchReset.bind(this);
		this.barbarianReq = this.barbarianReq.bind(this);
		this.buildHardwareForm = this.buildHardwareForm.bind(this);
		this.buildNewOrderForm = this.buildNewOrderForm.bind(this);
		this.buildSvcRecordForm = this.buildSvcRecordForm.bind(this);
		this.buildSvcQuoteForm = this.buildSvcQuoteForm.bind(this);
		this.buildModRecordForm = this.buildModRecordForm.bind(this);
		this.buildModQuoteForm = this.buildModQuoteForm.bind(this);
		this.buildProjectForm = this.buildProjectForm.bind(this);
		this.buildProgramForm = this.buildProgramForm.bind(this);
		this.buildProgramContentForm = this.buildProgramContentForm.bind(this);
		this.buildProgramFormFoundataion = this.buildProgramFormFoundataion.bind(
			this
		);
		this.buildProgramFeaturesForm = this.buildProgramFeaturesForm.bind(this);
		this.buildProgramModificationsForm = this.buildProgramModificationsForm.bind(
			this
		);
		this.buildPurchaseOrderForm = this.buildPurchaseOrderForm.bind(this);
		this.buildServiceCallForm = this.buildServiceCallForm.bind(this);
		this.castToBool = this.castToBool.bind(this);
		this.changeActiveItem = this.changeActiveItem.bind(this);
		this.changeModalSubsection = this.changeModalSubsection.bind(this);
		this.changeComboFocus = this.changeComboFocus.bind(this);
		this.changeSection = this.changeSection.bind(this);
		this.changeSubsection = this.changeSubsection.bind(this);
		this.checkFormChange = this.checkFormChange.bind(this);
		this.createOneBuilding = this.createOneBuilding.bind(this);
		this.createOnePC = this.createOnePC.bind(this);
		this.createOneMonitor = this.createOneMonitor.bind(this);
		this.deleteSingleRecord = this.deleteSingleRecord.bind(this);
		this.duplicateOneMonitor = this.duplicateOneMonitor.bind(this);
		this.duplicateOnePC = this.duplicateOnePC.bind(this);
		this.failGracefully = this.failGracefully.bind(this);
		this.forceFormChange = this.forceFormChange.bind(this);
		this.forgotPasswordRequest = this.forgotPasswordRequest.bind(this);
		this.getRouteFromAdminSubsection = this.getRouteFromAdminSubsection.bind(
			this
		);
		this.getRouteAndData = this.getRouteAndData.bind(this);
		this.getQueryParam = this.getQueryParam.bind(this);
		this.goToAdmin = this.goToAdmin.bind(this);
		this.goBackToSplash = this.goBackToSplash.bind(this);
		this.goToCreateNew = this.goToCreateNew.bind(this);
		this.goToDelete = this.goToDelete.bind(this);
		this.goToPortal = this.goToPortal.bind(this);
		this.goToUserAdmin = this.goToUserAdmin.bind(this);
		this.handleAdminValueChange = this.handleAdminValueChange.bind(this);
		this.handleFuzzyChange = this.handleFuzzyChange.bind(this);
		this.handleGetFuzzy = this.handleGetFuzzy.bind(this);
		this.handleGetRouteFromSearch = this.handleGetRouteFromSearch.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
		this.hideUserModal = this.hideUserModal.bind(this);
		this.horrifyingLoop = this.horrifyingLoop.bind(this);
		this.isBetterArray = this.isBetterArray.bind(this);
		this.makeAdminTable = this.makeAdminTable.bind(this);
		this.makeDupModal = this.makeDupModal.bind(this);
		this.makeLabel = this.makeLabel.bind(this);
		this.md5GetQueryParams = this.md5GetQueryParams.bind(this);
		this.md5PostXAuthHeaders = this.md5PostXAuthHeaders.bind(this);
		this.pad = this.pad.bind(this);
		this.postSection = this.postSection.bind(this);
		this.postSingleSection = this.postSingleSection.bind(this);
		this.showSelectedRecord = this.showSelectedRecord.bind(this);
		this.showUserModal = this.showUserModal.bind(this);
		this.stopTheMadness = this.stopTheMadness.bind(this);
		this.submitUserEdit = this.submitUserEdit.bind(this);
		this.submitUserPermissionGroupEdit = this.submitUserPermissionGroupEdit.bind(this);
		this.newBuildingRecord = this.newBuildingRecord.bind(this);
		this.newModRecord = this.newModRecord.bind(this);
		this.newModRecordFromQuote = this.newModRecordFromQuote.bind(this);
		this.newModQuote = this.newModQuote.bind(this);
		this.newSvcRecord = this.newSvcRecord.bind(this);
		this.newSvcQuote = this.newSvcQuote.bind(this);
		this.reportErr = this.reportErr.bind(this);
		this.resetUserSearch = this.resetUserSearch.bind(this);
		this.resetDataOnModalClose = this.resetDataOnModalClose.bind(this);
		this.setLoading = this.setLoading.bind(this);
		this.swapCSS = this.swapCSS.bind(this);
		this.redTheme = this.redTheme.bind(this);
		this.toggleBldgBatch = this.toggleBldgBatch.bind(this);
		this.setHardwareDuplicationModal = this.setHardwareDuplicationModal.bind(this);
		this.toggleMonitorBatch = this.toggleMonitorBatch.bind(this);
		this.togglePCBatch = this.togglePCBatch.bind(this);
		this.toggleBuildingModal = this.toggleBuildingModal.bind(this);
		this.toggleCreateModal = this.toggleCreateModal.bind(this);
		this.toggleDBView = this.toggleDBView.bind(this);
		this.toggleError = this.toggleError.bind(this);
		this.toggleHeaderDropDown = this.toggleHeaderDropDown.bind(this);
		this.toggleLoader = this.toggleLoader.bind(this);
		this.triggerFormAutoCompleteChange = this.triggerFormAutoCompleteChange.bind(
			this
		);
		this.triggerFormCurrencyChange = this.triggerFormCurrencyChange.bind(this);
		this.triggerFormValueChange = this.triggerFormValueChange.bind(this);
		this.triggerFormBoolChange = this.triggerFormBoolChange.bind(this);
		this.triggerFormDateChange = this.triggerFormDateChange.bind(this);
		this.updateUserPropertyNumbers = this.updateUserPropertyNumbers.bind(this);
		this.updateDupTargetAndType = this.updateDupTargetAndType.bind(this);
		this.userEmailSearch = this.userEmailSearch.bind(this);
		this.userSearch = this.userSearch.bind(this);
		this.validateUserPermissionGroup = this.validateUserPermissionGroup.bind(this);
		this.validateUserPropertyNumbers = this.validateUserPropertyNumbers.bind(this);
		this.writeData = this.writeData.bind(this);
	}

	componentDidMount() {
		let propNum = this.getQueryParam('propNum');
		if (propNum) {
			this.handleGetRouteFromSearch(propNum);
		}


		if (!localStorage.theme) {
			console.log('No theme found');
		} else {
			console.log(`Theme ${localStorage.theme}`);
			console.log(parseInt(localStorage.theme, 10));
			this.setState({
				theme: parseInt(localStorage.theme, 10)
			});
		}

		let head = document.head;
		let link = document.createElement('link');
		link.type = 'text/css';
		link.rel = 'stylesheet';
		link.id = 'themeLink';
		link.href = './theme.css';
		if (parseInt(localStorage.theme, 10) === 1) {
			head.appendChild(link);
			this.setState({
				themeName: 'DARK'
			});
		}
	}

	forceFormChange() {
		// this func is why code review is important
		let nextState = Object.assign({}, this.state.dbData);
		switch (this.state.section) {
			case 'PROJECT': {
				let projectForm = this.buildProjectForm(nextState.data);
				this.setState({ dbData: nextState, projectForm: projectForm }, () => {
					this.checkFormChange();
				});
			}
				break;
			case 'PROGRAM': {
				let programForm = this.buildProgramForm(nextState.data);
				this.setState({ dbData: nextState, programForm: programForm }, () => {
					this.checkFormChange();
				});
			}
				break;
			case 'HARDWARE': {
				let hardwareForm = this.buildHardwareForm(nextState.data);
				console.log(this.state.showHardwareDuplication);
				this.setState({ dbData: nextState, hardwareForm: hardwareForm }, () => {
					console.log('Rebuilding Hardware Form');
					console.log(this.state.showHardwareDuplication);
					this.checkFormChange();
				});
			}
				break;
			default:
				this.setState({ dbData: nextState }, () => {
					this.checkFormChange();
				});
		}
	}

	getQueryParam(param) {
		let query = window.location.search.substring(1);
		let vars = query.split('&');
		for (let i = 0; i < vars.length; i++) {
			let pair = vars[i].split('=');
			if (pair[0] === param) {
				return pair[1];
			}
		}
		return false;
	}

	md5GetQueryParams() {
		let ts = parseInt(new Date().getTime() / 1000, 10);
		let sKey = md5(`${SESSION_KEY}_${ts}`);
		return `auth_id=${SESSION_KEY}&auth_key=${sKey}&auth_ts=${ts}`;
	}

	md5PostXAuthHeaders() {
		let ts = parseInt(new Date().getTime() / 1000, 10);
		let sKey = md5(`${SESSION_KEY}_${ts}`);
		let headers = {
			'X-Auth-ID': SESSION_KEY,
			'X-Auth-Key': sKey,
			'X-Auth-TS': ts
		};
		return headers;
	}

	pad(n, width, z) {
		z = z || '0';
		n = n + '';
		if (n.length >= width) {
			return n;
		}
		return new Array(width - n.length + 1).join(z) + n;
	}

	setLoading(bool) {
		this.setState({ loading: bool });
	}

	goToPortal() {
		if (!this.state.dbData.data.property_number) {
			return console.log('No Prop Nums');
		}

		let targetURL = `${PORTAL_PREFIX}/#/from-atlas/${this.state.dbData.data.property_number}`;

		window.open(targetURL, '_blank');
		return console.log(this.state.dbData.data.property_number);
	}

	updateDupTargetAndType(target, type) {
		this.setState({ dupTarget: target, dupTargetType: type });
	}

	setHardwareDuplicationModal(show) {
		console.log(`Changing FROM: ${this.state.showHardwareDuplication} TO ${show}`);
		this.setState({ showHardwareDuplication: show }, () => {
			this.forceFormChange();
		});
	}

	adminUpdate() {
		let subsection = this.state.subsection;
		let section = this.state.section;
		this.setState({ loading: true });
		let usefulSubsection = subsection.toLowerCase();
		let targetSection = this.state.adminData[usefulSubsection];

		let frozenData = JSON.parse(this.state.adminOriginal);
		let frozenSection = frozenData[usefulSubsection];

		targetSection.forEach((entry, i) => {
			if (
				!this.areEqual(JSON.stringify(entry), JSON.stringify(frozenSection[i]))
			) {
				let suffix = this.getRouteFromAdminSubsection(subsection);
				let authHeaders = this.md5PostXAuthHeaders();
				let dataURL = `${API_PREFIX}/bronco/legacy/${suffix}/`;

				fetch(dataURL, {
					body: JSON.stringify(entry),
					method: 'POST',
					headers: Object.assign(
						{ 'content-type': 'application/json' },
						authHeaders
					)
				})
					.then((res) => {
						if (!res.ok) {
							return false;
						}
						this.goToAdmin(() => {
							this.setState({ subsection: subsection, section: section, loading: false });
						});
					})
					.catch((err) => {
						this.setState({ subsection: subsection, section: section, loading: false, error: 'Failed to update DB' });
					});
			}
		});
	}

	adminWrite(subsection, value) {
		let section = this.state.section;
		this.setState({ loading: true });
		let postObj = {};
		let routeSuffix = '';
		switch (subsection) {
			case 'EMPLOYEES':
				postObj.emp_name = value;
				routeSuffix = 'customersEmployees';
				break;
			case 'EXIT_METHODS':
				postObj.exit_method = value;
				routeSuffix = 'customersExitmethods';
				break;
			case 'INSTALLATION_TYPES':
				postObj.installation_type = value;
				routeSuffix = 'customersInstallationtypes';
				break;
			case 'LEADSOURCES':
				postObj.lead_source = value;
				routeSuffix = 'customersLeadsources';
				break;
			case 'MODELS':
				postObj.name = value;
				routeSuffix = 'customersModels';
				break;
			case 'ORIENTATIONS':
				postObj.orientation = value;
				routeSuffix = 'customersOrientations';
				break;
			case 'SALESPERSONS':
				postObj.salesperson = value;
				routeSuffix = 'customersSalespersons';
				break;
			case 'STATES':
				postObj.state = value;
				routeSuffix = 'customersStates';
				break;
			case 'TIMEZONES':
				postObj.time_zone = value;
				routeSuffix = 'customersTimeZones';
				break;
			case 'TS_ADMIN_VERSIONS':
				postObj.ts_admin_version = value;
				routeSuffix = 'customersTSAdminVersions';
				break;
			case 'UPDATING_TYPES':
				postObj.updating_type = value;
				routeSuffix = 'customersUpdatingTypes';
				break;
			case 'WARRANTY_TYPES':
				postObj.warr_type = value;
				routeSuffix = 'customersWarrantyTypes';
				break;
			default:
				let err =
					'Attempted to write to an unknown section from the admin forms.';
				this.setState({ error: err, loading: false, section: section });
				return;
		}

		let headers = this.md5PostXAuthHeaders();
		let targetURL = `${API_PREFIX}/bronco/legacy/${routeSuffix}/`;

		fetch(targetURL, {
			body: JSON.stringify(postObj),
			method: 'POST',
			headers: Object.assign({ 'content-type': 'application/json' }, headers)
		})
			.then((res) => {
				if (!res.ok) {
					return false;
				}
				this.goToAdmin(() => {
					this.setState({ subsection: subsection, section: section, loading: false });
				});
			})
			.catch((err) => {
				this.setState({ error: 'Failed to update DB', section: section, loading: false });
			});
	}

	makeAdminTable(subsection) {
		let columns = [];
		let userCheck = false;
		switch (subsection) {
			case 'EMPLOYEES':
				columns.push(
					{
						Header: 'Name',
						accessor: 'emp_name'
					},
					{
						Header: 'PIN',
						accessor: 'emp_pin'
					},
					{
						Header: 'Comment',
						accessor: 'comment'
					},
					{
						Header: 'Status',
						accessor: 'status'
					},
					{
						Header: 'Door ID PIN',
						accessor: 'door_id_pin'
					},
					{
						Header: 'Door ID Card',
						accessor: 'door_id_card'
					},
					{
						Header: 'Door Code Card',
						accessor: 'door_code_card'
					}
				);
				break;
			case 'EXIT_METHODS':
				columns.push(
					{
						Header: 'Exit Method',
						accessor: 'exit_method'
					},
					{
						Header: 'Sort Key',
						accessor: 'sortkey'
					},
					{
						Header: 'Description',
						accessor: 'description'
					}
				);
				break;
			case 'INSTALLATION_TYPES':
				columns.push(
					{
						Header: 'Installation Type',
						accessor: 'installation_type'
					},
					{
						Header: 'Description',
						accessor: 'description'
					},
					{
						Header: 'Sortkey',
						accessor: 'sortkey'
					},
					{
						Header: 'Hide C',
						accessor: 'hide_c'
					},
					{
						Header: 'Hide P',
						accessor: 'hide_p'
					},
					{
						Header: 'DNU',
						accessor: 'dnu'
					}
				);
				break;
			case 'LEADSOURCES':
				columns.push(
					{
						Header: 'LeadSource',
						accessor: 'lead_source'
					},
					{
						Header: 'Sortkey',
						accessor: 'sortkey'
					}
				);
				break;
			case 'MODELS':
				columns.push(
					{
						Header: 'Name',
						accessor: 'name'
					},
					{
						Header: 'Warranty Model',
						accessor: 'warranty_model'
					},
					{
						Header: 'Warranty Manufacturer',
						accessor: 'warranty_manufacturer'
					},
					{
						Header: 'Category',
						accessor: 'category'
					},
					{
						Header: 'Type',
						accessor: 'type'
					},
					{
						Header: 'Sortkey',
						accessor: 'sortkey'
					},
					{
						Header: 'ForSetupRpt',
						accessor: 'for_setup_rpt'
					},
					{
						Header: 'Visible',
						accessor: 'visible'
					},
					{
						Header: 'Description',
						accessor: 'description'
					},
					{
						Header: 'Cost',
						accessor: 'cost'
					},
					{
						Header: 'SvcPrice',
						accessor: 'svc_price'
					},
					{
						Header: 'Ext Warranty 1',
						accessor: 'ext_warranty_1'
					},
					{
						Header: 'Ext Warranty 3',
						accessor: 'ext_warranty_3'
					},
					{
						Header: 'Ship 2 Day',
						accessor: 'ship_2_day'
					},
					{
						Header: 'Ship Ground',
						accessor: 'ship_ground'
					},
					{
						Header: 'Ship Canada',
						accessor: 'ship_canada'
					},
					{
						Header: 'Svc Quote Visible',
						accessor: 'svc_quote_visible'
					},
					{
						Header: 'No Ext Warranty',
						accessor: 'no_ext_warr'
					}
				);
				break;
			case 'ORIENTATIONS':
				columns.push(
					{
						Header: 'Orientation',
						accessor: 'orientation'
					},
					{
						Header: 'Sort Order',
						accessor: 'sort_order'
					}
				);
				break;
			case 'SALESPERSONS':
				columns.push(
					{
						Header: 'Salesperson',
						accessor: 'salesperson'
					},
					{
						Header: 'DisplaySort',
						accessor: 'display_sort'
					}
				);
				break;
			case 'STATES':
				columns.push(
					{
						Header: 'State',
						accessor: 'state'
					},
					{
						Header: 'State Name',
						accessor: 'state_name'
					},
					{
						Header: 'Country',
						accessor: 'country'
					}
				);
				break;
			case 'TIMEZONES':
				columns.push(
					{
						Header: 'TimeZone',
						accessor: 'time_zone'
					},
					{
						Header: 'Sort Key',
						accessor: 'sort_key'
					},
					{
						Header: 'Description',
						accessor: 'description'
					}
				);
				break;
			case 'TS_ADMIN_VERSIONS':
				columns.push(
					{
						Header: 'TS Admin Version',
						accessor: 'ts_admin_version'
					},
					{
						Header: 'Sort Key',
						accessor: 'sort_key'
					},
					{
						Header: 'Description',
						accessor: 'description'
					}
				);
				break;
			case 'UPDATING_TYPES':
				columns.push(
					{
						Header: 'Updating Type',
						accessor: 'updating_type'
					},
					{
						Header: 'Sort Key',
						accessor: 'sortkey'
					}
				);
				break;
			case 'WARRANTY_TYPES':
				columns.push(
					{
						Header: 'WarrType',
						accessor: 'warr_type'
					},
					{
						Header: 'Sort Key',
						accessor: 'sortkey'
					},
					{
						Header: 'Fee',
						accessor: 'fee'
					}
				);
				break;
			case 'USERS':
				userCheck = true;
				columns.push(
					{
						Header: 'Edit',
						accessor: 'edit',
						width: 65
					},
					{
						Header: 'Username',
						accessor: 'metadata',
						width: 150
					},
					{
						Header: 'Email',
						accessor: 'email',
						width: 200
					},
					{
						Header: 'Permission Group',
						accessor: 'metadata',
						width: 200
					},
					{
						Header: 'Properties - Numbers & Commas ONLY!',
						accessor: 'metadata'
					},
					{
						Header: 'Reset',
						accessor: 'reset',
						width: 120
					},
					// {
					// 	Header:   'Delete',
					// 	accessor: 'delete',
					// 	width:    80
					// },
				);
				break;
			default:
				let err =
					'Attempted to create a table for an unknown section from the admin forms.';
				this.setState({ error: err });
				return;
		}

		if (userCheck) {
			return (
				<AdminTable
					columns={columns}
					changeEmailFilter={this.changeEmailFilter}
					changePropFilter={this.changePropFilter}
					data={this.state.userTableData}
					defaultPageSize={10}
					emailFilter={this.state.emailFilter}
					handleAdminValueChange={this.handleAdminValueChange}
					handleUserValueChange={this.handleUserValueChange}
					handleUserPropertyValidation={this.handleUserPropertyValidation}
					handleUserPropertyChange={this.handleUserPropertyChange}
					hideUserModal={this.hideUserModal}
					propNums={this.state.propNums}
					propFilter={this.state.propFilter}
					permissionGroups={this.state.permissionGroups}
					resetUserSearch={this.resetUserSearch}
					showUserForm={this.state.showUserForm}
					showUserModal={this.showUserModal}
					submitUserEdit={this.submitUserEdit}
					subsection={this.state.subsection}
					themeName={this.state.themeName}
					userEmailSearch={this.userEmailSearch}
					userFormData={this.state.userFormData}
					userSearch={this.userSearch}
				/>
			);

		}

		return (
			<AdminTable
				columns={columns}
				data={this.state.adminData[subsection.toLowerCase()]}
				defaultPageSize={10}
				handleAdminValueChange={this.handleAdminValueChange}
				handleUserValueChange={this.handleUserValueChange}
				subsection={this.state.subsection}
			/>
		);
	}

	resetUserSearch() {
		this.setState({ userTableData: this.state.userData });
	}

	userSearch(filterString) {
		this.setState({
			userMsg: 'Filtering table please wait...'
		});
		let allUsers = this.state.userData.slice(0);
		let nextTableUsers = [];
		for (let i = 0, x = allUsers.length; i < x; i++) {
			let user = allUsers[i];
			let pushIt = false;

			let properties = user.metadata.properties;

			for (let j = 0, y = properties.length; j < y; j++) {
				let prop = properties[j].toString();
				console.log(prop);
				if (prop.indexOf(filterString) > -1) {
					pushIt = true;
					break;
				}
			}

			if (pushIt) {
				nextTableUsers.push(user);
			}
		}
		this.setState({
			userTableData: nextTableUsers,
			userMsg: ''
		});
	}

	userEmailSearch(filterString) {
		this.setState({
			userMsg: 'Filtering table please wait...'
		});
		let allUsers = this.state.userData.slice(0);
		let nextTableUsers = [];
		for (let i = 0, x = allUsers.length; i < x; i++) {
			let user = allUsers[i];

			if (user.email.indexOf(filterString) > -1) {
				nextTableUsers.push(user);
			}
		}
		this.setState({
			userTableData: nextTableUsers,
			userMsg: ''
		});
	}

	showUserModal(userFormData) {
		this.setState({
			showUserForm: true,
			userFormData: userFormData
		});
	}

	hideUserModal() {
		this.setState({
			showUserForm: false,
			userFormData: {
				email: '',
				properties: [],
				permissionGroup: '',
				username: ''
			}
		});
	}

	validateUserPermissionGroup(targetData) {
		let result = true;
		if (
			typeof targetData === 'undefined' ||
			typeof targetData.metadata === 'undefined' ||
			typeof targetData.metadata.permissionGroup === 'undefined' ||
			typeof targetData.metadata.permissionGroup.id === 'undefined'
		) {
			result = false;
		}

		return result;
	}

	validateUserPropertyNumbers(targetData) {
		let result = true;
		if (
			typeof targetData === 'undefined' ||
			typeof targetData.metadata === 'undefined' ||
			typeof targetData.metadata.properties === 'undefined'
		) {
			result = false;
		}

		return result;
	}

	async submitUserEdit(newData, checkData, deleteCmd) {
		this.setState({ loading: true });
		// TODO: ADD SPECIFIC HANDLERS FROM BELOW TO HERE:
		if (deleteCmd) {
			let userURL = `${ROLLER_PREFIX}/delete/?session_key=${SESSION_KEY}`;
			let submission = JSON.stringify(Object.assign({}, newData));
			let deleteResp = await fetch(userURL, {
				body: submission,
				method: 'POST',
				headers: { 'content-type': 'application/json' }
			});

			if (!deleteResp.ok) {
				window.alert('Failed to delete User, aborting other edits.');
				return this.setState({ loading: false });
			}

			if (!this.validateUserPermissionGroup(newData) || !this.validateUserPermissionGroup(checkData)) {
				window.alert('Was unable to update permissionGroup (\'Role\') due to error checking for change, will still update other fields');
				return this.setState({ loading: false });
			}

			let newPG = {
				permission_group_id: 0,
				user_id: 0
			};
			let prevPG = {
				permission_group_id: checkData.metadata.permissionGroup.id,
				user_id: checkData.id
			};

			let permissionGroupResponse = await this.submitUserPermissionGroupEdit(newPG, prevPG);
			if (!permissionGroupResponse) {
				window.alert('Was unable to update permissionGroup (\'Role\') due to error posting back, will still update other fields');
				return this.setState({ loading: false });
			}

			if (!this.validateUserPropertyNumbers(newData) || !this.validateUserPropertyNumbers(checkData)) {
				window.alert('Was unable to update propertyNumbers due to error checking for change, concluding update');
				this.setState({
					propNums: [],
					loading: false,
					showUserForm: false,
					userData: [],
					userTableData: []
				});
			}

			let addedPropertyNumbers = [];
			let propNumSuccess = await this.updateUserPropertyNumbers(newData.id, newData.email, addedPropertyNumbers, newData.metadata.properties);
			if (!propNumSuccess) {
				this.setState({ error: 'Failed to update propertyNumbers due to bad request' });
			}

			this.setState({
				propNums: [],
				loading: false,
				showUserForm: false,
				userData: [],
				userTableData: []
			});
		}

		if (newData.id === 0) {
			let userURL = `${ROLLER_PREFIX}/create/?session_key=${SESSION_KEY}`;
			let submission = JSON.stringify(Object.assign({}, newData));
			let createResp = await fetch(userURL, {
				body: submission,
				method: 'POST',
				headers: { 'content-type': 'application/json' }
			});

			if (!createResp.ok) {
				window.alert('Failed to create User, aborting other edits');
				return this.setState({ loading: false });
			}

			let createReply = await createResp.json();
			if (
				!createReply ||
				!createReply.data ||
				!createReply.data.id
			) {
				window.alert('Create User response is missing subproperty `id` of property `data`, aborting other edits');
			}

			if (!this.validateUserPermissionGroup(newData)) {
				window.alert('Was unable to update permissionGroup (\'Role\') due to error checking for change, aborting other edits');
				return this.setState({ loading: false });
			}

			console.log(`About to use ID ${createReply.data.id} in POST back`);
			let newPG = {
				permission_group_id: newData.metadata.permissionGroup.id,
				user_id: createReply.data.id
			};
			let prevPG = {
				permission_group_id: 0,
				user_id: 0
			};

			let permissionGroupSuccess = await this.submitUserPermissionGroupEdit(newPG, prevPG);
			if (!permissionGroupSuccess) {
				window.alert('Was unable to update permissionGroup (\'Role\') due to error checking for change, aborting other edits');
				return this.setState({ loading: false });
			}

			if (!this.validateUserPropertyNumbers(newData)) {
				window.alert('Was unable to update permissionGroup (\'Role\') due to error checking for change, aborting other edits');
				return this.setState({ loading: false });
			}

			let removedPropertyNumbers = [];
			let propNumSuccess = await this.updateUserPropertyNumbers(newData.id, newData.email, newData.metadata.properties, removedPropertyNumbers);
			if (!propNumSuccess) {
				this.setState({ error: 'Failed to update propertyNumbers due to bad request' });
			}

			this.setState({
				propNums: [],
				loading: false,
				showUserForm: false,
				userData: [],
				userTableData: []
			});
		}

		if (
			this.validateUserPermissionGroup(newData) &&
			this.validateUserPermissionGroup(checkData) &&
			checkData.metadata.permissionGroup.id !== newData.metadata.permissionGroup.id
		) {
			console.log('In set new property group');
			let newPG = {
				permission_group_id: newData.metadata.permissionGroup.id,
				user_id: newData.id
			};
			let prevPG = {
				permission_group_id: checkData.metadata.permissionGroup.id,
				user_id: checkData.id
			};
			let permissionGroupSuccess = await this.submitUserPermissionGroupEdit(newPG, prevPG);
			if (!permissionGroupSuccess) {
				window.alert('Was unable to update permissionGroup (\'Role\') due to error checking for change, aborting other edits');
				return this.setState({
					loading: false,
					showUserForm: false,
					propNums: [],
					userData: [],
					userTableData: []
				});
			}
		} else {
			console.log('Skipping permission group...');
		}

		this.setState({
			showUserForm: false,
			propNums: [],
			userData: [],
			userTableData: []
		});

		// Now for properties
		if (!this.validateUserPropertyNumbers(checkData) || !this.validateUserPropertyNumbers(newData)) {
			window.alert('Was unable to update property numbers due to error checking for changes, will still update other fields');
			console.log('CHECK DATA:');
			console.log(checkData);
			console.log('FORM DATA:');
			console.log(newData);
		} else {
			let removedPropertyNumbers = [];
			let addedPropertyNumbers = [];

			checkData.metadata.properties.forEach((prevPropNum) => {
				let found = false;
				for (let i = 0, x = newData.metadata.properties.length; i < x; i++) {
					let nextPropNum = newData.metadata.properties[i];
					if (prevPropNum === nextPropNum) {
						found = true;
						return;
					}
				}
				if (!found) {
					removedPropertyNumbers.push(prevPropNum);
				}
			});

			newData.metadata.properties.forEach((nextPropNum) => {
				let found = false;
				for (let i = 0, x = checkData.metadata.properties.length; i < x; i++) {
					let prevPropNum = checkData.metadata.properties[i];
					if (nextPropNum === prevPropNum) {
						found = true;
						return;
					}
				}
				if (!found) {
					addedPropertyNumbers.push(nextPropNum);
				}
			});

			let userID = newData.id;
			let userEmail = newData.email;

			if (addedPropertyNumbers.length > 0 || removedPropertyNumbers.length > 0) {
				let propNumSuccess = await this.updateUserPropertyNumbers(userID, userEmail, addedPropertyNumbers, removedPropertyNumbers);
				if (!propNumSuccess) {
					this.setState({ error: 'Failed to successfully update properties' });
				}
			}
		}

		this.setState({ loading: false });
	}

	async updateUserPropertyNumbers(userID, userEmail, addedPropertyNumbers, removedPropertyNumbers) {
		console.log('ADDED:');
		let deleteURL = `${ROLLER_PREFIX}/deletePropertyNumber/?session_key=${SESSION_KEY}`;
		let addURL = `${ROLLER_PREFIX}/createPropertyNumber/?session_key=${SESSION_KEY}`;
		let addSuccess = true;
		let removeSuccess = true;

		for (let propNum of addedPropertyNumbers) {
			console.log(propNum);
			let postData = {
				user_email: userEmail,
				propnum: propNum
			};

			let resp = await fetch(addURL, {
				method: 'POST',
				body: JSON.stringify(postData),
				headers: { 'content-type': 'application/json' }
			}).catch((_err) => {
				addSuccess = false;
			});

			if (!resp.ok) {
				console.log('ERROR IN ADD PROPERTY NUMBER:');
				console.log(resp);
				addSuccess = false;
			}
		}

		console.log('REMOVED:');
		for (let propNum of removedPropertyNumbers) {
			console.log(propNum);
			let postData = {
				user_id: userID,
				propnum: propNum
			};

			let resp = await fetch(deleteURL, {
				method: 'POST',
				body: JSON.stringify(postData),
				headers: { 'content-type': 'application/json' }
			}).catch((_err) => {
				removeSuccess = false;
			});

			if (!resp.ok) {
				console.log('ERROR IN ADD PROPERTY NUMBER:');
				console.log(resp);
				removeSuccess = false;
			}
		}
		return (addSuccess && removeSuccess);
	}

	async submitUserPermissionGroupEdit(newPG, prevPG) {
		let prevSuccess = true;
		let nextSuccess = true;

		if (prevPG.permission_group_id !== 0) {
			let deleteURL = `${ROLLER_PREFIX}/deletePermissionGroup/?session_key=${SESSION_KEY}`;
			let prevBody = JSON.stringify(prevPG);

			let resp = await fetch(deleteURL, {
				body: prevBody,
				method: 'POST',
				headers: { 'content-type': 'application/json' }
			});
			if (!resp.ok) {
				prevSuccess = false;
			}
		}

		if (newPG.permission_group_id !== 0) {
			let editURL = `${ROLLER_PREFIX}/editPermissionGroup/?session_key=${SESSION_KEY}`;
			let nextBody = JSON.stringify(newPG);

			let resp = await fetch(editURL, {
				body: nextBody,
				method: 'POST',
				headers: { 'content-type': 'application/json' }
			});
			if (!resp.ok) {
				nextSuccess = false;
			}
		}

		return (nextSuccess && prevSuccess);
	}


	forgotPasswordRequest(email) {
		let reqBody = JSON.stringify({ email: email });
		console.log(`About to POST: ${reqBody}`);
		let pwdURL = `${ROLLER_PREFIX}/forgotPassword/?session_key=${SESSION_KEY}`;
		fetch(pwdURL, {
			method: 'POST',
			body: reqBody,
			headers: { 'content-type': 'application/json' }
		}).then((res) => {
			if (!res.ok) {
				return false;
			}
			return res.json();
		}).then((success) => {
			if (success) {
				return alert(`Password has been reset for email ${email}`);
			}
			return this.setState({ userMsg: 'Failed to reset password, an error has occurred' });
		});
	}

	changeActiveItem(nextState) {
		this.setState(nextState, () => {
			let nextProgramForm = this.buildProgramForm(this.state.dbData.data);
			let nextHardwareForm = this.buildHardwareForm(this.state.dbData.data);
			this.setState({ programForm: nextProgramForm, hardwareForm: nextHardwareForm });
		});
	}

	castToBool(stringBool) {
		let realBool = false;
		if (stringBool === '1') {
			realBool = true;
		}

		return realBool;
	}

	changeComboFocus(nextFocus) {
		let usefulData = Object.assign({}, this.state.dbData.data);
		this.setState({ comboFocus: nextFocus }, () => {
			let programForm = this.buildProgramForm(usefulData);
			let projectForm = this.buildProjectForm(usefulData);
			let hardwareForm = this.buildHardwareForm(usefulData);
			this.setState({
				programForm: programForm,
				projectForm: projectForm,
				hardwareForm: hardwareForm
			});
		});
	}

	changeSection(nextSection) {
		let usefulData = Object.assign({}, this.state.dbData.data);
		let nextSubSection = 'MAIN';

		this.setState(
			{
				error: '',
				section: nextSection,
				subsection: nextSubSection
			},
			() => {
				switch (nextSection) {
					case 'PROJECT': {
						let projectForm = this.buildProjectForm(usefulData);
						this.setState({ section: nextSection, projectForm: projectForm, loading: false });
						break;
					}
					case 'PROGRAM': {
						let programForm = this.buildProgramForm(usefulData);
						this.setState({ section: nextSection, programForm: programForm, loading: false });
						break;
					}
					case 'HARDWARE': {
						let hardwareForm = this.buildHardwareForm(usefulData);
						this.setState({ section: nextSection, hardwareForm: hardwareForm, loading: false });
						break;
					}
					default:
						this.setState({ loading: false });
				}
			}
		);
	}

	changeSubsection(nextSubsection) {
		let usefulData = Object.assign({}, this.state.dbData.data);
		this.setState(
			{
				subsection: nextSubsection
			},
			() => {
				switch (this.state.section) {
					case 'PROJECT': {
						let projectForm = this.buildProjectForm(usefulData);
						this.setState({ projectForm: projectForm });
						break;
					}
					case 'PROGRAM': {
						let programForm = this.buildProgramForm(usefulData);
						this.setState({ programForm: programForm });
						break;
					}
					case 'HARDWARE': {
						let hardwareForm = this.buildHardwareForm(usefulData);
						this.setState({ hardwareForm: hardwareForm });
						break;
					}
					default:
				}
			}
		);
	}

	changeModalSubsection(nextModalSubsection) {
		this.setState({ createModalSubsection: nextModalSubsection });
	}

	checkFormChange() {
		let change = false;
		if (JSON.stringify(this.state.dbData) !== this.state.origData) {
			change = true;
		}
		this.setState({ formChanged: change });
	}

	deleteSingleRecord(targetSection, targetID) {
		if (this.state.formChanged) {
			return alert('Please save changes before adding or deleting records');
		}

		this.setState({ loading: true });
		let section = this.state.dbData.data[targetSection];
		if (!this.isBetterArray(section)) {
			this.setState({
				error: 'Submitted a non-array to be deleted as an array entry. Please correct in the code.',
				loading: false
			});
		}

		let targetHolder = [];
		section.some((entry) => {
			if (entry.ID === targetID) {
				targetHolder.push(entry);
			}
			return entry.ID === targetID;
		});

		targetHolder[0].DeletedAt = moment()
			.format('YYYY-MM-DDTHH:mm:ssZ')
			.toString();

		let postBody = JSON.stringify(targetHolder[0]);
		let usefulRoute = targetHolder[0].bronco.route;
		let headers = this.md5PostXAuthHeaders();
		let dataURL = `${API_PREFIX}/bronco/legacy/${usefulRoute}/`;
		let currentSection = this.state.section;
		let currentSubsection = this.state.subsection;

		fetch(dataURL, {
			body: postBody,
			method: 'POST',
			headers: Object.assign({ 'content-type': 'application/json' }, headers)
		})
			.then((res) => {
				return res.json();
			})
			.then((json) => {
				this.handleGetRouteFromSearch(this.state.route, () => {
					this.setState({
						section: currentSection,
						subsection: currentSubsection
					}, () => {
						let targetData = Object.assign({}, this.state.dbData.data);
						let programForm = this.buildProgramForm(targetData);
						let projectForm = this.buildProjectForm(targetData);
						let hardwareForm = this.buildHardwareForm(targetData);
						this.setState({
							loading: false,
							hardwareForm: hardwareForm,
							programForm: programForm,
							projectForm: projectForm
						});
					});
				});
			})
			.catch((err) => {
				return this.setState({
					error: `${err} -- Please check your network connection.`,
					loading: false
				});
			});
	}

	handleGetRouteFromSearch(propNum, callback = () => { }) {
		this.setState(
			{
				routeHolder: propNum,
				loading: true
			},
			() => {
				this.getRouteAndData(callback);
			}
		);
	}

	handleGetFuzzy(event) {
		event.preventDefault();
		this.setState({ loading: true });

		let authHeaders = this.md5PostXAuthHeaders();
		const dataURL = `${API_PREFIX}/bronco/legacy/donkey/`;

		let fuzzyObj = { terms: this.state.fuzzyFindValue };
		let fuzzyBody = JSON.stringify(fuzzyObj);

		let errorCheck = false;

		fetch(dataURL, {
			body: fuzzyBody,
			method: 'POST',
			headers: Object.assign(
				{ 'content-type': 'application/json' },
				authHeaders
			)
		})
			.catch((error) => {
				errorCheck = true;
				this.setState({
					error: `${error} -- Please check your network connection.`,
					loading: false
				});
			})
			.then((response) => {
				if (errorCheck) {
					return;
				}

				return response.json();
			})
			.catch((error) => {
				errorCheck = true;
				this.setState({
					error: `The server response has the following issue -- ${error}`,
					loading: false
				});
			})
			.then((usefulJson) => {
				if (errorCheck) {
					return;
				}
				let replyData = Object.assign({}, usefulJson);
				if (this.isBetterArray(replyData.data) && replyData.data.length > 0) {
					this.setState({ searchResults: replyData.data, loading: false });
				} else {
					this.setState({ error: `No results found for: ${fuzzyObj.terms}`, loading: false });
				}
			});
	}

	getRouteFromAdminSubsection(subsection) {
		let routeSuffix = '';
		switch (subsection) {
			case 'EMPLOYEES':
				routeSuffix = 'customersEmployees';
				break;
			case 'EXIT_METHODS':
				routeSuffix = 'customersExitmethods';
				break;
			case 'INSTALLATION_TYPES':
				routeSuffix = 'customersInstallationtypes';
				break;
			case 'LEADSOURCES':
				routeSuffix = 'customersLeadsources';
				break;
			case 'MODELS':
				routeSuffix = 'customersModels';
				break;
			case 'ORIENTATIONS':
				routeSuffix = 'customersOrientations';
				break;
			case 'SALESPERSONS':
				routeSuffix = 'customersSalespersons';
				break;
			case 'STATES':
				routeSuffix = 'customersStates';
				break;
			case 'TIMEZONES':
				routeSuffix = 'customersTimeZones';
				break;
			case 'TS_ADMIN_VERSIONS':
				routeSuffix = 'customersTSAdminVersions';
				break;
			case 'UPDATING_TYPES':
				routeSuffix = 'customersUpdatingTypes';
				break;
			case 'WARRANTY_TYPES':
				routeSuffix = 'customersWarrantyTypes';
				break;
			default:
				let err = 'Attempted to write to an unknown section from the admin forms.';
				this.setState({ error: err });
				return;
		}

		return routeSuffix;
	}

	getRouteAndData(callback = () => { }) {
		this.setState({ loading: true });
		let qps = this.md5GetQueryParams();
		const dataURL = `${API_PREFIX}/bronco/legacy/donkey/${
			this.state.routeHolder
			}/?${qps}`;
		let errorCheck = false;

		fetch(dataURL)
			.catch((error) => {
				errorCheck = true;
				this.setState({
					error: `${error} -- Please check your network connection.`,
					loading: false
				});
			})
			.then((response) => {
				if (errorCheck) {
					return;
				}
				return response.json();
			})
			.catch((error) => {
				errorCheck = true;
				this.setState({
					error: `The server response has the following issue -- ${error}`,
					loading: false
				});
			})
			.then((usefulJson) => {
				if (errorCheck) {
					return;
				}
				let normalData = Object.assign({}, usefulJson);
				if (normalData.data.customer.ID === 0) {
					this.setState({
						error: `The server has responded that there is no record of Property Number ${
							this.state.routeHolder
							}`,
						loading: false
					});

					return;
				}
				/* STOP QUOTE TIME */
				let modQuotes, modRecords, svcQuotes, svcRecords, targetMod, targetSvc = false;
				let totalMods = [];
				let totalSvc = [];

				if (
					normalData.data.mod_quote &&
					normalData.data.mod_quote.length &&
					normalData.data.mod_quote.length > 0
				) {
					modQuotes = normalData.data.mod_quote;
				}

				if (
					normalData.data.modification &&
					normalData.data.modification.length &&
					normalData.data.modification.length > 0
				) {
					modRecords = normalData.data.modification;
				}

				if (
					normalData.data.service &&
					normalData.data.service.length &&
					normalData.data.service.length > 0
				) {
					svcRecords = normalData.data.service;
				}

				if (
					normalData.data.service_quote &&
					normalData.data.service_quote.length &&
					normalData.data.service_quote.length > 0
				) {
					svcQuotes = normalData.data.service_quote;
				}

				if (modQuotes && modRecords) {
					// do something
					totalMods = modQuotes.concat(modRecords);
				} else if (modQuotes) {
					// do something
					totalMods = modQuotes;
				} else if (modRecords) {
					// do something
					totalMods = modRecords;
				}

				if (totalMods.length > 0) {
					totalMods.sort(function (a, b) {
						let fieldA = typeof a.create_date !== 'undefined' ? 'create_date' : 'call_date';
						let fieldB = typeof b.create_date !== 'undefined' ? 'create_date' : 'call_date';
						a = new Date(a[fieldA]);
						b = new Date(b[fieldB]);
						return a > b ? -1 : a < b ? 1 : 0;
					});

					targetMod = totalMods[0];
				}

				if (svcQuotes && svcRecords) {
					totalSvc = svcQuotes.concat(svcRecords);
				} else if (svcQuotes) {
					totalSvc = svcQuotes;
				} else if (svcRecords) {
					totalSvc = svcRecords;
				}

				if (totalSvc.length > 0) {
					totalSvc.sort(function (a, b) {
						let fieldA = typeof a.create_date !== 'undefined' ? 'create_date' : 'call_date';
						let fieldB = typeof b.create_date !== 'undefined' ? 'create_date' : 'call_date';
						a = new Date(a[fieldA]);
						b = new Date(b[fieldB]);
						return a > b ? -1 : a < b ? 1 : 0;
					});

					targetSvc = totalSvc[0];
				}

				let frozenData = JSON.stringify(normalData);
				let projectForm = this.buildProjectForm(normalData.data);
				let programForm = this.buildProgramForm(normalData.data);
				let hardwareForm = this.buildHardwareForm(normalData.data);
				let targetModType, targetSvcType = false;

				if (targetMod) {
					targetModType = typeof targetMod.create_date !== 'undefined' ? 'quote' : 'record';
				}

				if (targetSvc) {
					targetSvcType = typeof targetSvc.create_date !== 'undefined' ? 'quote' : 'record';
				}

				this.setState(
					{
						activeMod: targetMod ? targetMod.ID : false,
						activeModType: targetModType,
						activeSvc: targetSvc ? targetSvc.ID : false,
						activeSvcType: targetSvcType,
						dbData: normalData,
						error: '',
						fuzzyFindValue: '',
						modRecords: totalMods,
						origData: frozenData,
						route: this.state.routeHolder,
						formChanged: false,
						routeHolder: '',
						searchResults: [],
						section: 'PROJECT',
						serviceRecords: totalSvc,
						subsection: 'MAIN',
						projectForm: projectForm,
						programForm: programForm,
						hardwareForm: hardwareForm,
						loading: false
					},
					() => {
						return callback();
					}
				);
			});
	}

	goBackToSplash() {
		this.setState({
			dbData: {},
			formChanged: false,
			origData: '',
			route: '',
			section: 'SPLASH',
			subsection: 'MAIN'
		});
	}

	goToAdmin(callback = () => { }) {
		let qps = this.md5GetQueryParams();
		const dataURL = `${
			API_PREFIX
			}/bronco/legacy/donkeyAdmin/?${qps}`;
		this.setState(
			{
				loading: true
			},
			() => {
				fetch(dataURL)
					.then((response) => {
						if (!response.ok) {
							return false;
						}

						return response.json();
					})
					.then((usefulJson) => {
						let normalData = Object.assign({}, usefulJson.data);
						let frozenData = JSON.stringify(normalData);
						this.setState(
							{
								adminData: normalData,
								adminOriginal: frozenData,
								section: 'ADMIN',
								subsection: 'EMPLOYEES',
								route: '',
								routeHolder: '',
								dbData: {},
								loading: false,
								origData: ''
							},
							() => {
								callback();
							}
						);
					})
					.catch((error) => {
						this.setState({
							error: `${error} -- Please check your network connection.`
						});
						return false;
					});
			}
		);
	}

	goToCreateNew() {
		this.setState({ loading: true });
		let qps = this.md5GetQueryParams();
		const dataURL = `${API_PREFIX}/bronco/legacy/donkey/1/?${qps}`;
		let errorCheck = false;

		fetch(dataURL)
			.catch((error) => {
				errorCheck = true;
				this.setState({
					error: `${error} -- Please check your network connection.`,
					loading: false
				});
			})
			.then((response) => {
				if (errorCheck) {
					return false;
				}

				return response.json();
			})
			.catch((error) => {
				errorCheck = true;
				this.setState({
					error: `The server response has the following issue -- ${error}`,
					loading: false
				});
			})
			.then((usefulJson) => {
				if (errorCheck) {
					return false;
				}
				let normalData = Object.assign({}, usefulJson);

				this.setState({
					dbData: normalData,
					formChanged: false,
					origData: '',
					route: '',
					createModalShow: true,
					createModalSection: 'NEW_PROJ',
					createModalSubsection: 'MAIN',
					section: 'SPLASH',
					subsection: 'MAIN',
					loading: false
				});
			});
	}

	goToDelete() {
		if (this.state.route === '' || this.state.route === '1') {
			return;
		}

		this.setState({
			createModalShow: true,
			createModalSection: 'DELETE',
			createModalSubsection: 'MAIN'
		});
	}

	goToUserAdmin() {
		this.setState({section: 'USER'});
	}

	triggerFormValueChange(event) {
		const rawID = event.target.id;
		const usefulArray = rawID.split('-');
		const updateSection = usefulArray[0];
		const updateID = parseInt(usefulArray[1], 10);
		const updateKey = usefulArray[2];
		const newValue = event.target.value;

		this.handleValueChange(updateID, updateSection, updateKey, newValue);
	}

	triggerFormCurrencyChange(newValue, rawID) {
		const usefulArray = rawID.split('-');
		const updateSection = usefulArray[0];
		const updateID = parseInt(usefulArray[1], 10);
		const updateKey = usefulArray[2];

		this.handleValueChange(updateID, updateSection, updateKey, newValue);
	}

	triggerFormAutoCompleteChange(event, rawID, newValue = false) {
		if (!newValue) {
			newValue = event.target.value;
		}

		const usefulArray = rawID.split('-');
		const updateSection = usefulArray[0];
		const updateID = parseInt(usefulArray[1], 10);
		const updateKey = usefulArray[2];

		this.handleValueChange(updateID, updateSection, updateKey, newValue);
	}

	triggerFormBoolChange(event, oldBool) {
		console.log(oldBool);
		const rawID = event.target.id;
		const usefulArray = rawID.split('-');
		const updateSection = usefulArray[0];
		const updateID = parseInt(usefulArray[1], 10);
		const updateKey = usefulArray[2];
		// let newValue = oldBool ? 'false' : 'true';
		let newValue = '0';
		if (oldBool === false) {
			newValue = '1';
		}

		this.handleValueChange(updateID, updateSection, updateKey, newValue);
	}

	triggerFormDateChange(rawID, date) {
		const usefulArray = rawID.split('-');
		const updateSection = usefulArray[0];
		const updateID = parseInt(usefulArray[1], 10);
		const updateKey = usefulArray[2];
		if (date === '') {
			return this.handleValueChange(updateID, updateSection, updateKey, '');
		}
		this.handleValueChange(updateID, updateSection, updateKey, date.toString());
	}

	toggleError() {
		this.setState({ error: '' });
	}

	toggleDBView() {
		this.setState({ loading: true });
		this.setState({ dbView: !this.state.dbView }, () => {
			let nextProgramForm = this.buildProgramForm(this.state.dbData.data);
			let nextProjectForm = this.buildProjectForm(this.state.dbData.data);
			let nextHardwareForm = this.buildHardwareForm(this.state.dbData.data);
			this.setState({
				loading: false,
				programForm: nextProgramForm,
				projectForm: nextProjectForm,
				hardwareForm: nextHardwareForm
			});
		});
	}

	toggleBuildingModal() {
		this.setState({ buildingModalShow: !this.state.buildingModalShow });
	}

	toggleCreateModal() {
		this.setState({ section: 'SPLASH', subsection: 'MAIN', createModalShow: !this.state.createModalShow });
	}

	toggleHeaderDropDown() {
		let newDDValue = !this.state.headerDropDown;
		this.setState({ headerDropDown: newDDValue });
	}

	isBetterArray(possibleArray) {
		return Boolean(possibleArray) && possibleArray.constructor === Array;
	}

	handleAdminValueChange(id, key, value) {
		let nextData = Object.assign({}, this.state.adminData);
		let targetSection = nextData[this.state.subsection.toLowerCase()];

		let nextSection = targetSection.map((entry) => {
			if (entry.ID !== id) {
				return entry;
			}

			let nextEntry = entry;
			nextEntry[key] = value;

			return nextEntry;
		});

		nextData[this.state.subsection.toLowerCase()] = nextSection;

		this.setState({ adminData: nextData });
	}

	handleValueChange(id, section, key, value) {
		let nextState = Object.assign({}, this.state.dbData);
		let targetSection = nextState.data[section];

		if (this.isBetterArray(targetSection)) {
			let nextSection = targetSection.map((entry) => {
				if (entry.ID !== id) {
					return entry;
				}
				let nextEntry = entry;
				nextEntry[key] = value;

				return nextEntry;
			});

			targetSection = nextSection;
		} else {
			targetSection[key] = value;
		}

		nextState.data[section] = targetSection;

		switch (this.state.section) {
			case 'PROJECT': {
				let projectForm = this.buildProjectForm(nextState.data);
				this.setState({ dbData: nextState, projectForm: projectForm }, () => {
					this.checkFormChange();
				});
			}
				break;
			case 'PROGRAM': {
				let programForm = this.buildProgramForm(nextState.data);
				this.setState({ dbData: nextState, programForm: programForm }, () => {
					this.checkFormChange();
				});
			}
				break;
			case 'HARDWARE': {
				let hardwareForm = this.buildHardwareForm(nextState.data);
				this.setState({ dbData: nextState, hardwareForm: hardwareForm }, () => {
					this.checkFormChange();
				});
			}
				break;
			default:
				this.setState({ dbData: nextState }, () => {
					this.checkFormChange();
				});
		}
	}

	handleFuzzyChange(event) {
		event.preventDefault();
		let nextValue = event.target.value;
		this.setState({ fuzzyFindValue: nextValue });
	}

	makeLabel(str) {
		return str
			.toLowerCase()
			.split('_')
			.map((word) => {
				if (word[0]) {
					return word[0].toUpperCase() + word.substr(1);
				}

				return word;
			})
			.join(' ');
	}

	// Start write data functions

	// used to detect the nature of data collisions:
	areEqual() {
		let x = arguments.length;
		for (let i = 1; i < x; i++) {
			if (arguments[i] === null || arguments[i] !== arguments[i - 1]) {
				return false;
			}
		}

		return true;
	}

	failGracefully() {
		let errString = '';
		let changeFields = [];

		let rawData = JSON.parse(this.state.origData);
		let oldData = rawData.data;
		let oldKeys = Object.keys(oldData);
		oldKeys.forEach((oldKey) => {
			let oldSection = oldData[oldKey];
			let newSection = this.state.dbData.data[oldKey];
			if (
				this.areEqual(JSON.stringify(newSection), JSON.stringify(oldSection))
			) {
				return;
			}

			if (this.isBetterArray(newSection)) {
				// TODO MAKE ARRAY HANDLING LOGIC
				newSection.forEach((section, i) => {
					let subsectionKeys = Object.keys(section);
					subsectionKeys.forEach((ssKey) => {
						if (
							ssKey === 'UpdatedAt' ||
							ssKey === 'bronco' ||
							ssKey === 'DeletedAt'
						) {
							return;
						}
						if (section[ssKey] !== oldSection[i][ssKey]) {
							errString += `You have changed entry #${i} of the ${oldKey} section for this property:\n`;
							errString += `The ${ssKey} field has gone\n`;
							errString += `FROM: ${oldSection[i][ssKey]}\n`;
							errString += `TO: ${newSection[i][ssKey]}\n`;
						}
					});
				});
			} else {
				let sectionKeys = Object.keys(oldSection);
				sectionKeys.forEach((sectionKey) => {
					if (
						sectionKey === 'UpdatedAt' ||
						sectionKey === 'bronco' ||
						sectionKey === 'DeletedAt'
					) {
						return;
					}
					if (oldSection[sectionKey] !== newSection[sectionKey]) {
						errString += 'You have changed:\n';
						errString += `The ${oldKey} table's ${sectionKey} field\n`;
						errString += `FROM: ${oldSection[sectionKey]}\n`;
						errString += `TO: ${newSection[sectionKey]}\n`;
					}
				});
			}
		});

		if (errString !== '') {
			changeFields.push(
				<Fragment key={1}>
					<p>
						Due to edits to this record from other sources after your original
						loading of the record, your changes could not be saved.
					</p>
					<p>
						Here is a complete list of what you have changed. Please copy these
						changes, reload the record, and re-apply them.
					</p>
					<p>
						This is a feature, not a bug. We are all looking forward to Bronco.
					</p>
				</Fragment>
			);

			changeFields.push(
				<Fragment key={2}>
					<Input type="textarea" value={errString} id="collision-helper" />
				</Fragment>
			);

			changeFields.push(
				<Fragment key={3}>
					<Button
						color="info"
						onClick={() => {
							let target = document.getElementById('collision-helper');
							target.select();
							document.execCommand('copy');
						}}
					>
						Copy Changed Fields Info
					</Button>
				</Fragment>
			);
		}
		return changeFields;
	}

	// used to detect discrepancies in array sections:
	arrayDiscrepencyCheck(checkerObj) {
		// loop through the objects in the array.
		// Is everything even there?
		if (
			!checkerObj.frozenSection ||
			!checkerObj.dbSection ||
			!checkerObj.formSection
		) {
			console.log('HALTING 1');
			checkerObj.halt = true;
			return checkerObj;
		}

		checkerObj.frozenSection.forEach((frozenEntry, i) => {
			// Seriously, Is everything even there?
			if (
				!frozenEntry ||
				!checkerObj.dbSection[i] ||
				!checkerObj.formSection[i]
			) {
				checkerObj.halt = true;
				return checkerObj;
			}
			// if this object is all matched, return.
			if (
				this.areEqual(
					JSON.stringify(frozenEntry),
					JSON.stringify(checkerObj.dbSection[i]),
					JSON.stringify(checkerObj.formSection[i])
				)
			) {
				return checkerObj;
			}


			// so there is a change, iteration time!
			let secKeys = Object.keys(frozenEntry);
			let usefulID = frozenEntry.ID;
			secKeys.forEach((secKey) => {
				// a deletion collision?
				if (
					!frozenEntry[secKey] ||
					!checkerObj.dbSection[i][secKey] ||
					!checkerObj.formSection[i][secKey]
				) {
					console.log('HALTING SEC 1');
					checkerObj.halt = true;
					return;
				}
				// skippable?
				if (
					secKey === 'UpdatedAt' ||
					secKey === 'bronco' ||
					secKey === 'DeletedAt'
				) {
					return;
				}

				// all equal?
				if (
					this.areEqual(
						frozenEntry[secKey],
						checkerObj.dbSection[i][secKey],
						checkerObj.formSection[i][secKey]
					)
				) {
					return;
				}

				// wholly discrepant?
				if (
					!this.areEqual(
						frozenEntry[secKey],
						checkerObj.dbSection[i][secKey]
					) &&
					!this.areEqual(
						frozenEntry[secKey],
						checkerObj.formSection[i][secKey]
					) &&
					!this.areEqual(
						checkerObj.dbSection[i][secKey],
						checkerObj.formSection[i][secKey]
					)
				) {
					console.log('WHOLLY DISCREPANT');
					checkerObj.discrepantFields.push(
						`${checkerObj.key} -- ID: ${usefulID} -- ${secKey}`
					);

					return;
				}

				// an expected change?
				if (
					!this.areEqual(frozenEntry[secKey], checkerObj.formSection[secKey])
				) {
					checkerObj.okFields.push(
						`${checkerObj.key} -- ID: ${usefulID} -- ${secKey}`
					);

					return;
				}

				// a needed merge of new data:
				if (!this.areEqual(frozenEntry[secKey], checkerObj.dbSection[secKey])) {
					checkerObj.changedFields.push(
						`${checkerObj.key}:${i}:${secKey}:${checkerObj.dbSection[secKey]}`
					);
					// checkerObj.formData[checkerObj.key][i][secKey] = checkerObj.dbSection[secKey];
				}
			});
		});

		return checkerObj;
	}

	writeData() {
		if (!this.state.formChanged) {
			return window.alert('No changes detected.');
		}

		let halt = false;

		this.setState({ error: '', loading: true });
		let qps = this.md5GetQueryParams();
		const dataURL = `${API_PREFIX}/bronco/legacy/donkey/${
			this.state.route
			}/?${qps}`;
		let errorCheck = false;

		fetch(dataURL)
			.catch((error) => {
				errorCheck = true;
				this.setState({
					error: `${error} -- Please check your network connection.`,
					loading: false
				});
			})
			.then((response) => {
				if (errorCheck) {
					return false;
				}
				return response.json();
			})
			.catch((error) => {
				errorCheck = true;
				this.setState({
					error: `The server response has the following issue -- ${error}`,
					loading: false
				});
			})
			.then((usefulJson) => {
				if (errorCheck) {
					return false;
				}
				console.log(usefulJson);
				let newDBDataWrapper = Object.assign({}, usefulJson);
				if (newDBDataWrapper.data.customer.ID === 0) {
					this.setState({
						error: `The server has responded that there is no record of Property Number ${
							this.state.routeHolder
							}`,
						loading: false
					});
					return;
				}

				// Moving PCs or Monitors Confirm Message
				let newData = this.state.dbData.data;
				let oldData = newDBDataWrapper.data;
				let messages = [];

				if (!newData.pc) {
					newData.pc = [];
				}

				newData.pc.forEach((section, i) => {
					if (!oldData.pc[i] || !section) {
						return;
					}

					if (!this.areEqual(JSON.stringify(oldData.pc[i].project), JSON.stringify(section.project))) {
						messages.push(`Move PC from ${oldData.pc[i].project} to ${section.project}?`);
					}
				});

				if (!newData.monitor) {
					newData.monitor = [];
				}

				newData.monitor.forEach((section, i) => {
					if (!oldData.monitor[i] || !section) {
						return;
					}

					if (!this.areEqual(JSON.stringify(oldData.monitor[i].project), JSON.stringify(section.project))) {
						messages.push(`Move Monitor from ${oldData.monitor[i].project} to ${section.project}?`);
					}
				});

				if (messages.length > 0) {
					messages.push(`Are you sure?`);
					if (!window.confirm(messages.join('\n'))) {
						this.setState({
							loading: false,
							dbData: newDBDataWrapper
						});
						this.forceFormChange();
						return;
					}
				}

				if (JSON.stringify(newDBDataWrapper) !== this.state.origData) {
					let frozenDataWrapper = JSON.parse(this.state.origData);
					let frozenData = frozenDataWrapper.data;

					let newDBData = newDBDataWrapper.data;

					let formData = Object.assign({}, this.state.dbData.data);
					let frozenKeys = Object.keys(frozenData);

					let discrepantFields = [];
					let okFields = [];
					let changedFields = [];

					frozenKeys.forEach((key, i) => {

						let frozenSection = frozenData[key];
						let dbSection = newDBData[key];
						let formSection = formData[key];

						let compareFrozen = JSON.stringify(frozenSection);
						let compareDB = JSON.stringify(dbSection);
						let compareForm = JSON.stringify(formSection);

						if (this.areEqual(compareDB, compareFrozen, compareForm)) {
							return;
						}

						// we know they aren't all undefined from the prev check.
						if (!frozenSection || !dbSection || !formSection) {
							console.log('Well that\'s a problem....');
							halt = true;
						}

						if (this.isBetterArray(frozenSection)) {
							let checkerObj = {
								key: key,
								frozenSection: frozenSection,
								dbSection: dbSection,
								formSection: formSection,
								compareFrozen: compareFrozen,
								compareDB: compareDB,
								compareForm: compareForm,
								discrepantFields: discrepantFields,
								okFields: okFields,
								changedFields: changedFields,
								halt: false
							};

							checkerObj = this.arrayDiscrepencyCheck(checkerObj);
							if (checkerObj.halt) {
								console.log('HALTING FROM ARRAY DISCREPANCY CHECK');
								halt = true;
								return;
							}

							checkerObj.discrepantFields.forEach((disc) => {
								discrepantFields.push(disc);
							});
							checkerObj.okFields.forEach((ok) => {
								okFields.push(ok);
							});
							checkerObj.changedFields.forEach((chng) => {
								changedFields.push(chng);
							});
							return;
						}

						let secKeys = Object.keys(formSection);
						secKeys.forEach((secKey, i) => {
							// skippable?
							if (
								secKey === 'UpdatedAt' ||
								secKey === 'bronco' ||
								secKey === 'DeletedAt'
							) {
								return;
							}

							// all equal?
							if (
								this.areEqual(
									frozenSection[secKey],
									dbSection[secKey],
									formSection[secKey]
								)
							) {
								return;
							}

							// wholly discrepant?
							if (
								!this.areEqual(frozenSection[secKey], dbSection[secKey]) &&
								!this.areEqual(frozenSection[secKey], formSection[secKey]) &&
								!this.areEqual(dbSection[secKey], formSection[secKey])
							) {
								console.log('WHOLLY DISCREPANT');
								discrepantFields.push(`${key} -- ${secKey}`);
								return;
							}

							// an expected change?
							if (!this.areEqual(frozenSection[secKey], formSection[secKey])) {
								okFields.push(`${key} -- ${secKey}`);

								return;
							}

							// a needed merge of new data:
							if (!this.areEqual(frozenSection[secKey], dbSection[secKey])) {
								changedFields.push(`${key}:${secKey}:${dbSection[secKey]}`);
							}
						});
					});

					console.log('Before we check discrepancies:');
					console.log('OK FIELDS:');
					for (let i = 0, x = okFields.length; i < x; i++) {
						console.log(okFields[i]);
					}

					console.log('CHANGED FIELDS:');
					for (let i = 0, x = changedFields.length; i < x; i++) {
						console.log(changedFields[i]);
					}

					console.log('DISCREPANT FIELDS');
					for (let i = 0, x = discrepantFields.length; i < x; i++) {
						console.log(discrepantFields[i]);
					}

					if (halt) {
						console.log('HALTING');
						console.log('FROZEN:');
						console.log(frozenData);
						console.log('FORM:');
						console.log(formData);
						console.log('NEW:');
						console.log(newDBData);
						let msg = this.failGracefully();
						this.setState({
							error: msg,
							loading: false
						});
						return;
					}


					console.log('About to check discrepancies...');
					if (changedFields.length > 0 && discrepantFields.length === 0) {
						console.log('Found No Discrepant Fields');
						let nextData = Object.assign({}, this.state.dbData);
						changedFields.forEach((field) => {
							let fieldArray = field.split(':');

							if (fieldArray.length === 3) {
								nextData.data[fieldArray[0]][fieldArray[1]] = fieldArray[2];
							}

							if (fieldArray.length === 4) {
								nextData.data[fieldArray[0]][fieldArray[1]][fieldArray[2]] = fieldArray[3];
							}
						});

						this.setState({ dbData: nextData, origData: JSON.stringify(usefulJson) }, () => {
							this.writeData();
						});
						return;

						// POSSIBLE FIX
						// this.setState({dbData: nextData});
					}

					if (discrepantFields.length > 0) {
						let msg = this.failGracefully();
						this.setState({
							error: msg,
							loading: false
						});
						return;
					}
				}

				console.log('discrepancy checked passed, about to proceed with post-back.');
				// Continue standard behavoir:
				let contextObj = {};
				contextObj.writeDataPrefix = `${API_PREFIX}/bronco/legacy/`;

				contextObj.shortHand = this.state.dbData.data;
				contextObj.compare = newDBDataWrapper.data;
				contextObj.promises = [];

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.monitor),
						JSON.stringify(contextObj.compare.monitor)
					)
				) {
					contextObj.shortHand.monitor.forEach((section, i) => {
						if (!this.areEqual(JSON.stringify(contextObj.compare.monitor[i]), JSON.stringify(section))) {
							contextObj.promises.push(
								// this.postSingleSection(contextObj.writeDataPrefix, section)
								{
									prefix: contextObj.writeDataPrefix,
									section: section
								}
							);
						}
					});
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.pc),
						JSON.stringify(contextObj.compare.pc)
					)
				) {
					contextObj.shortHand.pc.forEach((section, i) => {
						if (!this.areEqual(JSON.stringify(contextObj.compare.pc[i]), JSON.stringify(section))) {
							contextObj.promises.push(
								// this.postSingleSection(contextObj.writeDataPrefix, section)
								{
									prefix: contextObj.writeDataPrefix,
									section: section
								}
							);
						}
					});
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.service),
						JSON.stringify(contextObj.compare.service)
					)
				) {

					contextObj.shortHand.service.forEach((section, i) => {
						if (!this.areEqual(JSON.stringify(contextObj.compare.service[i]), JSON.stringify(section))) {
							contextObj.promises.push(
								// this.postSingleSection(contextObj.writeDataPrefix, section)
								{
									prefix: contextObj.writeDataPrefix,
									section: section
								}
							);
						}
					});
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.service_quote),
						JSON.stringify(contextObj.compare.service_quote)
					)
				) {

					contextObj.shortHand.service_quote.forEach((section, i) => {
						if (!this.areEqual(JSON.stringify(contextObj.compare.service_quote[i]), JSON.stringify(section))) {
							contextObj.promises.push(
								// this.postSingleSection(contextObj.writeDataPrefix, section)
								{
									prefix: contextObj.writeDataPrefix,
									section: section
								}
							);
						}
					});
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.building),
						JSON.stringify(contextObj.compare.building)
					)
				) {
					contextObj.shortHand.building.forEach((section, i) => {
						if (!this.areEqual(JSON.stringify(contextObj.compare.building[i]), JSON.stringify(section))) {
							contextObj.promises.push(
								// this.postSingleSection(contextObj.writeDataPrefix, section)
								{
									prefix: contextObj.writeDataPrefix,
									section: section
								}
							);
						}
					});
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.user),
						JSON.stringify(contextObj.compare.user)
					)
				) {
					contextObj.promises.push(
						{
							prefix: contextObj.writeDataPrefix,
							section: contextObj.shortHand.user
						}

						// this.postSingleSection(
						// 	contextObj.writeDataPrefix,
						// 	contextObj.shortHand.user
						// )

					);
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.content),
						JSON.stringify(contextObj.compare.content)
					)
				) {
					contextObj.promises.push(
						{
							prefix: contextObj.writeDataPrefix,
							section: contextObj.shortHand.content
						}
						// this.postSingleSection(
						// 	contextObj.writeDataPrefix,
						// 	contextObj.shortHand.content
						// )
					);
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.modification),
						JSON.stringify(contextObj.compare.modification)
					)
				) {
					contextObj.shortHand.modification.forEach((section, i) => {
						if (!this.areEqual(JSON.stringify(contextObj.compare.modification[i]), JSON.stringify(section))) {
							contextObj.promises.push(
								{
									prefix: contextObj.writeDataPrefix,
									section: section
								}
								// this.postSingleSection(contextObj.writeDataPrefix, section)
							);
						}
					});
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.mod_quote),
						JSON.stringify(contextObj.compare.mod_quote)
					)
				) {
					contextObj.shortHand.mod_quote.forEach((section) => {
						if (!this.areEqual(JSON.stringify(contextObj.compare.mod_quote[i]), JSON.stringify(section))) {
							contextObj.promises.push(
								{
									prefix: contextObj.writeDataPrefix,
									section: section
								}
								// this.postSingleSection(contextObj.writeDataPrefix, section)
							);
						}
					});
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.purchase_order),
						JSON.stringify(contextObj.compare.purchase_order)
					)
				) {
					contextObj.shortHand.purchase_order.forEach((section) => {
						if (!this.areEqual(JSON.stringify(contextObj.compare.purchase_order[i]), JSON.stringify(section))) {
							contextObj.promises.push(
								{
									prefix: contextObj.writeDataPrefix,
									section: section
								}
								// this.postSingleSection(contextObj.writeDataPrefix, section)
							);
						}
					});
				}

				if (
					!this.areEqual(
						JSON.stringify(contextObj.shortHand.customer),
						JSON.stringify(contextObj.compare.customer)
					)
				) {
					contextObj.promises.push(
						{
							prefix: contextObj.writeDataPrefix,
							section: contextObj.shortHand.customer
						}
						// this.postSingleSection(
						// 	contextObj.writeDataPrefix,
						// 	contextObj.shortHand.customer
						// )
					);
				}

				let promiseLen = contextObj.promises.length;
				let i = 0;
				this.setState({ uploadProgress: `${i}/${promiseLen} uploads complete` });

				let callback = this.stopTheMadness;
				this.horrifyingLoop(i, promiseLen, contextObj.promises, callback);
			});
	}

	horrifyingLoop(index, target, array, callback) {
		// here's hopin you've got a big stack
		return new Promise((resolve, reject) => {
			if (index >= target) {
				callback();
				resolve(true);
			}

			this.postSingleSection(array[index].prefix, array[index].section).then((success) => {
				index++;
				this.setState({ uploadProgress: `${index}/${target} uploads complete` });
				this.horrifyingLoop(index, target, array, callback);
			}).catch((fail) => {
				this.setState({ loading: false });
				reject(true);
			});
		});
	}

	stopTheMadness() {
		this.setState({
			routeHolder: this.state.route,
			route: '',
			section: 'SPLASH',
			subsection: 'MAIN',
			loading: true,
			uploadProgress: ''
		});
		this.getRouteAndData();
	}

	barbarianReq(propNum) {
		if (this.state.formChanged) {
			return window.alert('Please save your changes first to be able to push them to barbarian');
		}
		let targetURL = `${BARBARIAN_PREFIX}/?propnum=${propNum}`;
		this.setState({ loading: true });
		fetch(targetURL).then((res) => {
			this.setState({ loading: false });
			if (res.ok) {
				window.alert('SUCCESS!');
			} else {
				window.alert(`Failed, status text received: ${res.statusText}`);
			}
			// console.log('Barbarian Res:');
			// console.log(res);
			// let json = res.json();
			// console.log(json);
			// if (json.message) {
			// 	console.log(json.message);
			// }
		});
	}

	postSection(writeDataPrefix, section, compare) {
		if (!section || !compare) {
			return;
		}

		if (this.areEqual(JSON.stringify(section), JSON.stringify(compare))) {
			return;
		}

		if (this.isBetterArray(section)) {
			section.forEach((sectPart) => {
				this.postSingleSection(writeDataPrefix, sectPart);
			});

			return;
		}

		this.postSingleSection(writeDataPrefix, section);
	}

	postSingleSection(writeDataPrefix, origObj) {
		return new Promise((resolve, reject) => {
			let updateObj = {};
			let updateKeys = Object.keys(origObj);
			let authHeaders = this.md5PostXAuthHeaders();
			let updateURL = `${writeDataPrefix}${origObj.bronco.route}/`;

			updateKeys.forEach((key) => {
				if (key !== 'bronco') {
					updateObj[key] = origObj[key];
				}
			});

			fetch(updateURL, {
				body: JSON.stringify(updateObj),
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.then((res) => {
					if (!res.ok) {
						return reject();
					}
					return resolve();
				})
				.catch((error) => {
					this.setState({
						error: `${error} -- Please check your network connection.`
					});

					return reject();
				});
		});
	}

	batchReset(section, subsection, route) {
		this.setState({ routeHolder: route }, () => {
			this.getRouteAndData(() => {
				this.setState({ section: section, subsection: subsection });
			});
		});
	}

	reportErr(err) {
		this.setState({ error: err });
	}

	createOneBuilding() {
		return new Promise((resolve, reject) => {
			let dataObj = {};
			dataObj.prop_num = this.state.dbData.data.customer.property_number;

			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/updateBuildings/`;

			let postObj = JSON.stringify(dataObj);
			let authHeaders = this.md5PostXAuthHeaders();

			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					console.log('POST FAILED:');
					console.error(error);
					return reject(
						this.setState({
							error: `${error} -- Please check your network connection.`
						})
					);
				})
				.then((res) => {
					return resolve(res);
				});

		});
	}

	swapCSS() {
		let head = document.head;
		let link = document.createElement('link');

		link.type = 'text/css';
		link.rel = 'stylesheet';
		link.id = 'themeLink';
		if (this.state.theme === 0) {
			let stylesheet = './theme.css';
			console.log('swapCSS stylesheet');
			link.href = stylesheet;

			head.appendChild(link);

			let themeButton = document.getElementById('styleSwap');
			themeButton.classList.add('craig');
			localStorage.theme = 1;
			this.setState({
				theme: 1,
				themeName: 'DARK'
			});
		} else {
			document.getElementById('themeLink').remove();
			localStorage.theme = 0;
			this.setState({
				theme: 0,
				themeName: 'LIGHT'
			});
		}

		// red mod - copy 2 lines into Dev Tools
		// var stylesheet = document.getElementById('themeLink');
		// stylesheet.href = '/theme2.css'
	}

	redTheme() {
		let head = document.head;
		let link = document.createElement('link');
		link.type = 'text/css';
		link.rel = 'stylesheet';
		link.id = 'themeLink';
		link.href = './theme2.css';

		if (!localStorage.theme) {
			head.appendChild(link);
		} else {
			document.getElementById('themeLink').setAttribute('href', './theme2.css');
		}

		this.setState({
			themeName: 'RED'
		});
	}

	render() {
		let buildingList = [];
		if (
			this.state.section !== 'SPLASH' &&
			this.state.section !== 'ADMIN' &&
			this.state.section !== 'LOADING' &&
			this.state.dbData.data &&
			this.state.dbData.data.building &&
			this.isBetterArray(this.state.dbData.data.building)
		) {
			buildingList = this.state.dbData.data.building;
		}


		let batchBuildingForm = (
			<BatchUploader
				batchFunc={this.createOneBuilding}
				barbarianFunc={this.barbarianReq}
				inputID="building-batch-upload"
				inputName="building-batch"
				show={this.state.showBldgBatch}
				toggle={this.toggleBldgBatch}
				loader={this.toggleLoader}
				modalToggle={this.toggleBuildingModal}
				resetPage={() => {
					return this.batchReset(this.state.section, this.state.subsection, this.state.route);
				}}
				reportErr={this.reportErr}
			/>
		);

		let dupModal = this.makeDupModal();

		return (
			<div className="App">
				<Header
					goBackToSplash={this.goBackToSplash}
					goToCreateNew={this.goToCreateNew}
					goToDelete={this.goToDelete}
					goToAdmin={this.goToAdmin}
					goToPortal={this.goToPortal}
					goToUserAdmin={this.goToUserAdmin}
					reportPrefix={REPORT_PREFIX}
					route={this.state.route}
					routeData={this.state.dbData.data}
					section={this.state.section}
					headerDropDown={this.state.headerDropDown}
					toggleHeaderDropDown={this.toggleHeaderDropDown}
				/>
				<ErrorHolder toggleError={this.toggleError} error={this.state.error} />
				<PMFViewer
					adminWrite={this.adminWrite}
					adminUpdate={this.adminUpdate}
					adminData={this.state.adminData}
					barbarianReq={this.barbarianReq}
					changeSection={this.changeSection}
					changeSubsection={this.changeSubsection}
					forgotPasswordRequest={this.forgotPasswordRequest}
					formChanged={this.state.formChanged}
					goToUserAdmin={this.goToUserAdmin}
					isBetterArray={this.isBetterArray}
					handleAdminValueChange={this.handleAdminValueChange}
					route={this.state.route}
					routeData={this.state.dbData.data}
					routeHolder={this.state.routeHolder}
					section={this.state.section}
					subsection={this.state.subsection}
					loading={this.state.loading}
					makeLabel={this.makeLabel}
					makeAdminTable={this.makeAdminTable}
					md5GetQueryParams={this.md5GetQueryParams}
					toggleDBView={this.toggleDBView}
					touchy={Touchy}
					triggerFormValueChange={this.triggerFormValueChange}
					fuzzyFindValue={this.state.fuzzyFindValue}
					handleFuzzyChange={this.handleFuzzyChange}
					searchResults={this.state.searchResults}
					showUserModal={this.showUserModal}
					handleGetFuzzy={this.handleGetFuzzy}
					handleGetRouteFromSearch={this.handleGetRouteFromSearch}
					writeData={this.writeData}
					programForm={this.state.programForm}
					projectForm={this.state.projectForm}
					hardwareForm={this.state.hardwareForm}
					themeSwap={this.swapCSS}
					themeRed={this.redTheme}
					themeName={this.state.themeName}
					uploadProgress={this.state.uploadProgress}
					userMsg={this.state.userMsg}
				/>
				<CreateModal
					apiPrefix={API_PREFIX}
					createModalShow={this.state.createModalShow}
					createModalSection={this.state.createModalSection}
					createModalSubsection={this.state.createModalSubsection}
					changeModalSubsection={this.changeModalSubsection}
					goBackToSplash={this.goBackToSplash}
					handleGetRouteFromSearch={this.handleGetRouteFromSearch}
					md5GetQueryParams={this.md5GetQueryParams}
					md5PostXAuthHeaders={this.md5PostXAuthHeaders}
					setLoading={this.setLoading}
					toggleCreateModal={this.toggleCreateModal}
					route={this.state.route}
					routeData={this.state.dbData.data}
					makeLabel={this.makeLabel}
				/>
				<BuildingModal
					batch={batchBuildingForm}
					buildingList={buildingList}
					buildingModalShow={this.state.buildingModalShow}
					deleteSingleRecord={this.deleteSingleRecord}
					newBuildingRecord={this.newBuildingRecord}
					showBatch={this.state.showBldgBatch}
					triggerFormBoolChange={this.triggerFormBoolChange}
					triggerFormValueChange={this.triggerFormValueChange}
					triggerFormDateChange={this.triggerFormDateChange}
					toggleBuildingModal={this.toggleBuildingModal}
					writeData={this.writeData}
				/>
				{dupModal}
			</div>
		);
	}

	buildSvcRecordForm(service) {
		if (!this.state.dbData || !this.state.dbData.data) {
			return (<div>No Data to Display</div>);
		}
		let routeData = this.state.dbData.data;

		let serviceKeys = Object.keys(service);
		let serviceForm = {};
		let displayDate = moment(service.call_date).format('MM.DD.YY');
		let callDate = `CALL ON ${displayDate}`;

		serviceKeys.forEach((key, j) => {
			switch (key) {
				case 'bronco':
				case 'ID':
				case 'id':
				case 'UpdatedAt':
				case 'CreatedAt':
				case 'DeletedAt':
					return;
				case 'service_type':
					serviceForm[key] = (
						<FormSelect
							key={`${service.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_service_types}
							currentValue={service[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={service.bronco.id_prefix}
						/>
					);
					break;
				case 'tech':
					serviceForm[key] = (
						<FormSelect
							key={`${service.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_techs}
							currentValue={service[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={service.bronco.id_prefix}
						/>
					);
					break;
				case 'model':
					serviceForm[key] = (
						<FormSelect
							key={`${service.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_monitor_model_types}
							currentValue={service[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={service.bronco.id_prefix}
						/>
					);
					break;
				case 'call_date':
				case 'cust_close_date':
				case 'resolved_date':
					serviceForm[key] = (
						<FormDatePicker
							colsize={6}
							key={`${service.bronco.id_prefix}-${j}`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							date={service[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={service.bronco.id_prefix}
						/>
					);
					break;
				case 'issue':
					serviceForm[key] = (
						<FormTextArea
							key={`${service.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={service[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={service.bronco.id_prefix}
							rows={20}
						/>
					);
					break;
				case 'resolution':
				case 'cause':
					serviceForm[key] = (
						<FormTextArea
							key={`${service.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={service[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={service.bronco.id_prefix}
						/>
					);
					break;
				default:
					serviceForm[key] = (
						<FormText
							key={`${service.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={service[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={service.bronco.id_prefix}
						/>
					);
			}
		});

		let serviceSection1 = [
			serviceForm.contact_name,
			serviceForm.contact_phone,
			serviceForm.model,
			serviceForm.sched_ship_date,
			serviceForm.serial_number,
			serviceForm.tech,
			serviceForm.service_type,
			serviceForm.cust_close_date,
			serviceForm.resolved_date,
			serviceForm.resolution,
			serviceForm.cause
		];

		let serviceSection2 = [
			serviceForm.issue
		];

		return (
			<ServiceCallForm
				key={`${callDate}_active`}
				title={callDate}
				colsize={12}
				section1={serviceSection1}
				section2={serviceSection2}
				deleteSingleRecord={() => {
					if (window.confirm('Delete this record?')) {
						return this.deleteSingleRecord('service', service.ID);
					}
				}}
			/>
		);

	}

	buildModRecordForm(mod) {
		if (!this.state.dbData || !this.state.dbData.data) {
			return (<div>No Data to Display</div>);
		}
		let routeData = this.state.dbData.data;
		let modObj = {};
		let displayDate = moment(mod.call_date).format('MM.DD.YY');
		let modTitle = `Modification ${displayDate}`;
		let modKeys = Object.keys(mod);

		modKeys.forEach((key, j) => {
			switch (key) {
				case 'id':
				case 'ID':
				case 'bronco':
				case 'CreatedAt':
				case 'UpdatedAt':
				case 'DeletedAt':
					return;
				case 'call_date':
				case 'finished_date':
				case 'due_date':
					modObj[key] = (
						<FormDatePicker
							colsize={12}
							key={`${mod.bronco.id_prefix}-${j}`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							date={mod[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				case 'approval':
					modObj[key] = (
						<FormSelect
							key={`${mod.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							currentValue={mod[key]}
							valueArray={routeData.all_mod_status}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				case 'transferred':
				case 'invoiced':
					modObj[key] = (
						<FormSelect
							key={`${mod.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							currentValue={mod[key]}
							valueArray={routeData.all_ynna_opts}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				case 'dsi_point_person':
					modObj[key] = (
						<FormSelect
							key={`${mod.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Assigned To"
							label={key}
							currentValue={mod[key]}
							valueArray={routeData.all_production_employees}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				case 'cost':
					modObj[key] = (
						<FormCurrency
							key={`${mod.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={mod[key]}
							triggerFormCurrencyChange={this.triggerFormCurrencyChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				case 'content':
					modObj[key] = (
						<FormSelect
							key={`${mod.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Content Received"
							label={key}
							currentValue={mod[key]}
							valueArray={routeData.all_ynna_opts}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				case 'programming':
					modObj[key] = (
						<FormSelect
							key={`${mod.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Programming Completed"
							label={key}
							currentValue={mod[key]}
							valueArray={routeData.all_ynna_opts}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				case 'graphics':
					modObj[key] = (
						<FormSelect
							key={`${mod.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Graphics Completed"
							label={key}
							currentValue={mod[key]}
							valueArray={routeData.all_ynna_opts}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				case 'description':
					modObj[key] = (
						<FormTextArea
							colsize={12}
							rows={18}
							key={`${mod.bronco.id_prefix}-${j}`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={mod[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
					break;
				default:
					modObj[key] = (
						<FormText
							key={`${mod.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={mod[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={mod.bronco.id_prefix}
						/>
					);
			}
		});

		let modFields = [
			modObj.contact_name,
			modObj.contact_phone,
			modObj.contact_email,
			modObj.call_date,
			modObj.due_date,
			modObj.dsi_point_person,
			modObj.description
		];
		let modFields2 = [
			modObj.content,
			modObj.approval,
			modObj.programming,
			modObj.graphics,
			modObj.transferred,
			modObj.finished_date,
			modObj.invoiced,
			modObj.cost
		];
		let modFields3 = [
			modObj.content_time,
			modObj.graphics_time,
			modObj.programming_time,
			modObj.transfer_time
		];


		return (
			<Row key={`mod-active`}>
				<Col xs={12}>
					<h4>{modTitle}
						<Button className="clearBtn miniBtnDelete headerIcon" onClick={() => {
							if (window.confirm('Delete this record?')) {
								return this.deleteSingleRecord('modification', mod.ID);
							}
						}}>
							<img src={Delete} className="deleteIcon" />
						</Button>
					</h4>
				</Col>
				<Col xs={6} >
					<FormSection
						fields={modFields}
					/>
				</Col>
				<Col xs={6} >
					<FormSection
						fields={modFields2}
					/>
					<FormSection
						fields={modFields3}
					/>
				</Col>
			</Row>
		);

	}

	buildModQuoteForm(quote) {
		if (!this.state.dbData || !this.state.dbData.data) {
			return (<div>No Data to Display</div>);
		}
		let routeData = this.state.dbData.data;
		let quoteObj = {};
		let displayDate = moment(quote.create_date).format('MM.DD.YY');
		let quoteTitle = `Quote ${displayDate}`;
		let quoteKeys = Object.keys(quote);
		quoteKeys.forEach((key, j) => {
			switch (key) {
				case 'id':
				case 'ID':
				case 'bronco':
				case 'CreatedAt':
				case 'UpdatedAt':
				case 'DeletedAt':
					return;
				case 'product_1_desc':
					quoteObj[key] = (
						<FormTextArea
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Description"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
							rows={8}
						/>
					);
					break;
				case 'invoice_company':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing Company"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}

						/>
					);
					break;
				case 'invoice_contact':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing Contact"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_address':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing Address"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_address_2':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing Suite"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_city':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing City"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_zip_postal':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Billing Zip"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'ap_contact':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing A/P Contact"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'ap_phone':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing A/P Phone"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'authorization_name':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Authorization Name (entered by client)"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'po_number':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="PO Number (if applicable)"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'product_1_price':
					quoteObj[key] = (
						<FormCurrency
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Price"
							label={key}
							value={quote[key]}
							triggerFormCurrencyChange={this.triggerFormCurrencyChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'tsi_contact':
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Prepared By"
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_production_employees}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'product_1':
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Product"
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_mod_quote_products}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_state_prov':
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Billing State/Prov"
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_states}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				default:
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
			}
		});

		let section1 = [
			quoteObj.tsi_contact,
			quoteObj.contact_name,
			quoteObj.contact_phone,
			quoteObj.contact_email,
			quoteObj.product_1,
			quoteObj.product_1_price,
			quoteObj.product_1_desc
		];

		let section2 = [
			quoteObj.invoice_company,
			quoteObj.invoice_contact,
			quoteObj.invoice_address,
			quoteObj.invoice_address_2,
			quoteObj.invoice_city,
			quoteObj.invoice_state_prov,
			quoteObj.invoice_zip_postal,
			quoteObj.ap_contact,
			quoteObj.ap_phone,
			quoteObj.authorization_name,
			quoteObj.po_number
		];

		let paddedID = this.pad(parseInt(quote.mod_quote_id), 10);
		let encodedID = window.btoa(paddedID);
		let formHREF = `${MOD_QUOTE_PREFIX}/?mod_id=${encodedID}&prop_num=${this.state.dbData.data.property_number}`;
		let formID = `mod-link-${quote.mod_quote_id}`;

		return (
			<Row>
				<Col xs={12}>
					<h4 className="ml-0 mt-0 mb-3">{quoteTitle}
						<a href={formHREF} target="_blank" className="headerIcon miniBtn">
							<img src={WebLink} className="webLink" />
						</a>
						<Button className="clearBtn miniBtnDelete headerIcon" onClick={() => {
							if (window.confirm('Delete this record?')) {
								return this.deleteSingleRecord('mod_quote', quote.ID);
							}
						}}>
							<img src={Delete} className="deleteIcon" />
						</Button>
					</h4>
				</Col>
				<Col xs={6}>
					<Row>{section1}</Row>
					{/* <button className="btn button mt-4" onClick={(e) => {
						this.newModRecordFromQuote(e, quote);
					}}>
							New Record From Quote
					</button> */}
				</Col>
				<Col xs={6}>
					<Row>{section2}</Row>
				</Col>
			</Row>
		);
	}

	buildSvcQuoteForm(quote) {
		if (!this.state.dbData || !this.state.dbData.data) {
			return (<div>No Data to Display</div>);
		}
		let routeData = this.state.dbData.data;
		let quoteObj = {};
		let displayDate = moment(quote.create_date).format('MM.DD.YY');
		let quoteTitle = `Quote ${displayDate}`;
		let quoteKeys = Object.keys(quote);
		quoteKeys.forEach((key, j) => {
			switch (key) {
				case 'id':
				case 'ID':
				case 'bronco':
				case 'CreatedAt':
				case 'UpdatedAt':
				case 'DeletedAt':
				case 'id_1___price':
				case 'id_2___price':
				case 'id_3___price':
				case 'ew___exp_date':
				case 'total_price':
					return;
				// case 'product_1_desc':  TODO:
				case 'invoice_company':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing Company"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_contact':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing Contact"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_address':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing Address"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_address_2':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing Suite"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_city':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing City"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_zip':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Billing Zip"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'ship_zip':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_equal_ship':
					quoteObj[key] = (
						<FormBool
							colsize={6}
							key={`${quote.bronco.id_prefix}-${j}`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'ap_contact':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing A/P Contact"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'ap_phone':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Billing A/P Phone"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'authorization_name':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Authorization Name (entered by client)"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'po_number':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="PO Number (if applicable)"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'ship_address_2':
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Ship Suite"
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'csr':
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Prepared By"
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_support_employees}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'invoice_state':
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Billing State/Prov"
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_states}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'ship_state':
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_states}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'model_id_1':
				case 'model_id_2':
				case 'model_id_3': {
					let labelNum = key[9];
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={`Model #${labelNum}`}
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_svc_model_types}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				}
				case 'ship_type_1':
				case 'ship_type_2':
				case 'ship_type_3':
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_ship_types}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'warranty_1':
				case 'warranty_2':
				case 'warranty_3':
					quoteObj[key] = (
						<FormSelect
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							currentValue={quote[key]}
							valueArray={routeData.all_svc_warranty_types}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				case 'approved_date':
					quoteObj[key] = (
						<FormDatePicker
							colsize={6}
							key={`${quote.bronco.id_prefix}-${j}`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							date={quote[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
					break;
				default:
					quoteObj[key] = (
						<FormText
							key={`${quote.bronco.id_prefix}-${j}`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={quote[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={quote.bronco.id_prefix}
						/>
					);
			}
		});

		let section1 = [
			quoteObj.csr,
			quoteObj.contact_name,
			quoteObj.contact_phone,
			quoteObj.contact_email,
			quoteObj.model_id_1,
			quoteObj.warranty_1,
			quoteObj.ship_type_1,
			quoteObj.id_1___price,
			quoteObj.model_id_2,
			quoteObj.warranty_2,
			quoteObj.ship_type_2,
			quoteObj.id_2___price,
			quoteObj.model_id_3,
			quoteObj.warranty_3,
			quoteObj.ship_type_3,
			quoteObj.id_3___price,
			quoteObj.ew___exp_date,
			quoteObj.total_price,
			quoteObj.authorization_name,
			quoteObj.po_number,
			quoteObj.approved_date
		];

		let section2 = [
			quoteObj.invoice_company,
			quoteObj.invoice_contact,
			quoteObj.invoice_address,
			quoteObj.invoice_address_2,
			quoteObj.invoice_city,
			quoteObj.invoice_state,
			quoteObj.invoice_zip,
			quoteObj.ap_contact,
			quoteObj.ap_phone,
			// quoteObj.invoice_equal_ship,
			// quoteObj.ship_name,
			quoteObj.ship_company,
			quoteObj.ship_contact,
			quoteObj.ship_address,
			quoteObj.ship_address_2,
			quoteObj.ship_city,
			quoteObj.ship_state,
			quoteObj.ship_zip
		];

		let paddedID = this.pad(parseInt(quote.svc_quote_id), 10);
		let encodedID = window.btoa(paddedID);
		let formHREF = `${SERVICE_QUOTE_PREFIX}/?service_id=${encodedID}&prop_num=${this.state.dbData.data.property_number}`;
		let formID = `mod-link-${quote.svc_quote_id}`;

		return (
			<Row>
				<Col xs={12}>
					<h4 className="ml-0 mt-0 mb-3">{quoteTitle}
						<a href={formHREF} target="_blank" className="headerIcon miniBtn">
							<img src={WebLink} className="webLink" />
						</a>
						<Button className="clearBtn miniBtnDelete headerIcon" onClick={() => {
							if (window.confirm('Delete this record?')) {
								return this.deleteSingleRecord('service_quote', quote.ID);
							}
						}}>
							<img src={Delete} className="deleteIcon" />
						</Button>
					</h4>


				</Col>
				<Col xs={6}>
					<Row>{section1}</Row>
				</Col>
				<Col xs={6}>
					<Row>{section2}</Row>
				</Col>
			</Row>
		);
	}

	// Start form building and never, ever stop.

	buildProjectForm(routeData) {
		let userKeys = Object.keys(routeData.user);
		let customerKeys = Object.keys(routeData.customer);
		let fieldObj = {};

		customerKeys.forEach((key, i) => {
			switch (key) {
				// Datepickers from Customers.
				case 'lead_date':
				case 'last_sale_date':
					fieldObj[key] = (
						<FormDatePicker
							colsize={6}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							date={routeData.customer[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'deposit_inv_date':
					fieldObj[key] = (
						<FormDatePicker
							colsize={6}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel="Deposit Invoice Date"
							label={key}
							date={routeData.customer[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// Bools from Customers.
				case 'kick_off_done':
					fieldObj[key] = (
						<FormBool
							colsize={6}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'lift_gate_req':
					fieldObj[key] = (
						<FormBool
							colsize={6}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel="Lift Gate Required"
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// half width text inputs.
				case 'billing_notes':
				case 'po':
				case 'contact_phone':
				case 'contact_fax':
					fieldObj[key] = (
						<FormText
							colsize={6}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'deposit_invoice':
					fieldObj[key] = (
						<FormCurrency
							key={`${i}-project-cust`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormCurrencyChange={this.triggerFormCurrencyChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'deposit_inv_no':
					fieldObj[key] = (
						<FormText
							colsize={6}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel="Deposit Invoice Number"
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// full width text inputs.
				case 'property_name':
				case 'site_address':
				case 'site_city':
				case 'client_name':
				case 'contact':
				case 'contact_email':
					fieldObj[key] = (
						<FormText
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'last_contact':
					fieldObj[key] = (
						<FormDatePicker
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							date={routeData.customer[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// full width text - can not edit.
				case 'project_id':
					fieldObj[key] = (
						<FormText
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// full width customLabel.
				case 'ko':
					fieldObj[key] = (
						<FormText
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel="Kick Off Status"
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;

				case 'aliases':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;

				case 'prop_mgr_address':
				case 'client_address':
				case 'last_contact_notes':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
							rows={10}
						/>
					);
					break;

				case 'ship_address':
				case 'bill_address':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
							rows={15}
						/>
					);
					break;

				// Dropdowns:
				case 'deposit_rcvd':
					fieldObj[key] = (
						<FormSelect
							colsize={6}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel="Deposit Received"
							label={key}
							valueArray={routeData.all_deposit_received}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'site_state':
					fieldObj[key] = (
						<FormSelect
							colsize={6}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_states}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'salesperson':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_sales_persons}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'lead_source':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_lead_sources}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'time_zone':
				case 'features':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-project-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_time_zones}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				default:
			}
		});

		userKeys.forEach((key, i) => {
			switch (key) {
				// dropdowns
				case 'cancel_reason':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-project-user`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_cancel_reasons}
							currentValue={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				case 'reseller':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-project-user`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_resellers}
							currentValue={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				// bools

				// case 'subscription_trial':
				// 	fieldObj[key] = (
				// 		<FormBool
				// 			colsize={6}
				// 			key={`${i}-project-user`}
				// 			dbView={this.state.dbView}
				// 			humanLabel={this.makeLabel(key)}
				// 			label={key}
				// 			value={routeData.user[key]}
				// 			triggerFormValueChange={this.triggerFormValueChange}
				// 			triggerFormBoolChange={this.triggerFormBoolChange}
				// 			parentID={routeData.user.bronco.id_prefix}
				// 		/>
				// 	);
				// 	break;

				// dates
				case 'online_expires':
				case 'web_news_expires':
				case 'cancel_date':
					fieldObj[key] = (
						<FormDatePicker
							colsize={6}
							key={`${i}-project-user`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							date={routeData.user[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				// half-width text inputs:
				case 'billing_state':
				case 'billing_postal':
				case 'mgmt_state':
				case 'mgmt_postal':
				case 'subscription_num':
					fieldObj[key] = (
						<FormText
							key={`${i}-project-user`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				case 'other_fee':
					fieldObj[key] = (
						<FormCurrency
							key={`${i}-project-user`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.user[key]}
							triggerFormCurrencyChange={this.triggerFormCurrencyChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				case 'web_news_fee':
					fieldObj[key] = (
						<FormCurrency
							key={`${i}-project-user`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="TS Live Fee"
							label={key}
							value={routeData.user[key]}
							triggerFormCurrencyChange={this.triggerFormCurrencyChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				case 'online_fee':
					fieldObj[key] = (
						<FormCurrency
							key={`${i}-project-user`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="TS Foundation Fee"
							label={key}
							value={routeData.user[key]}
							triggerFormCurrencyChange={this.triggerFormCurrencyChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				case 'warranty_fee':
					fieldObj[key] = (
						<FormCurrency
							key={`${i}-project-user`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Hardware Support Fee"
							label={key}
							value={routeData.user[key]}
							triggerFormCurrencyChange={this.triggerFormCurrencyChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				// full-width text inputs:
				case 'billing_company':
				case 'billing_contact':
				case 'billing_email':
				case 'billing_address_1':
				case 'billing_address_2':
				case 'billing_city':
				case 'billing_phone':
				case 'billing_fax':
				case 'mgmt_company':
				case 'mgmt_contact':
				case 'mgmt_email':
				case 'mgmt_address_1':
				case 'mgmt_address_2':
				case 'mgmt_city':
				case 'mgmt_phone':
				case 'mgmt_fax':
				// TODO MAKE INTO TEXT AREAS
				case 'other_fee_desc':
					fieldObj[key] = (
						<FormText
							key={`${i}-project-user`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				case 'cancel_notes':
					fieldObj[key] = (
						<FormTextArea
							key={`${i}-project-user`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				default:
			}
		});

		fieldObj.zip_postal = (
			<FormText
				key="zip_postal_project"
				colsize={6}
				dbView={this.state.dbView}
				humanLabel="Zip Code"
				label="zip_postal"
				value={routeData.content.zip_postal}
				triggerFormValueChange={this.triggerFormValueChange}
				parentID={routeData.content.bronco.id_prefix}
			/>
		);

		if (this.isBetterArray(routeData.pc)) {
			let revenueHolder = 0;
			let marginHolder = 0;
			routeData.pc.forEach((pcRecord) => {
				let revenue = parseFloat(pcRecord.revenue);
				if (pcRecord.revenue === '') {
					revenue = 0;
				}
				revenueHolder += revenue;
				let margin = parseFloat(pcRecord.gross_margin);
				marginHolder += margin;
			});

			fieldObj.total_revenue = (
				<FormText
					key="total_revenue"
					colsize={6}
					dbView={this.state.dbView}
					humanLabel="Total Revenue"
					label="total_revenue"
					value={`$${revenueHolder.toFixed(2)}`}
					disabled={true}
				/>
			);
			// TODO REMOVE IF NOT NEEDED:
			fieldObj.gross_margin = (
				<div>
					Gross Margin: <b>${marginHolder}</b>
				</div>
			);
		}

		fieldObj.usersTable = (
			<Col xs={4} key="user_tbl_btn">
				<Button onClick={() => {
					this.userSearch(this.state.dbData.data.property_number);
					this.setState({
						section: 'ADMIN',
						subsection: 'USERS',
						propFilter: this.state.dbData.data.property_number
					});
				}} className="button mt-2">
					Users Table
				</Button>
			</Col>
		);
		let projectFields = [];
		projectFields.push(
			fieldObj.property_name,
			fieldObj.aliases,
			fieldObj.site_address,
			fieldObj.site_city,
			fieldObj.site_state,
			fieldObj.zip_postal,
			fieldObj.time_zone,
			fieldObj.salesperson,
			fieldObj.lead_source,
			fieldObj.reseller,
			fieldObj.lead_date,
			fieldObj.last_sale_date,
			fieldObj.project_id,
			fieldObj.usersTable
		);

		let billingFields = [];
		billingFields.push(
			fieldObj.billing_company,
			fieldObj.billing_contact,
			fieldObj.billing_email,
			fieldObj.billing_address_1,
			fieldObj.billing_address_2,
			fieldObj.billing_city,
			fieldObj.billing_state,
			fieldObj.billing_postal,
			fieldObj.billing_phone,
			fieldObj.billing_fax,
			fieldObj.bill_address
		);

		let financeFields = [];
		financeFields.push(
			fieldObj.total_revenue,
			fieldObj.po,
			fieldObj.deposit_invoice,
			fieldObj.deposit_inv_no,
			fieldObj.deposit_inv_date,
			fieldObj.deposit_rcvd,
			fieldObj.web_news_fee,
			fieldObj.online_fee,
			fieldObj.warranty_fee,
			fieldObj.other_fee,
			fieldObj.subscription_num,
			// fieldObj.subscription_trial, // removed 03/25/18 As per DEV-648
			fieldObj.other_fee_desc,
			fieldObj.online_expires,
			fieldObj.cancel_date,
			fieldObj.cancel_reason,
			fieldObj.cancel_notes
		);

		let managementFields = [];
		managementFields.push(
			fieldObj.mgmt_company,
			fieldObj.mgmt_contact,
			fieldObj.mgmt_email,
			fieldObj.mgmt_address_1,
			fieldObj.mgmt_address_2,
			fieldObj.mgmt_city,
			fieldObj.mgmt_state,
			fieldObj.mgmt_postal,
			fieldObj.mgmt_phone,
			fieldObj.mgmt_fax,
			fieldObj.prop_mgr_address
		);

		let contactFields = [];
		contactFields.push(
			fieldObj.client_name,
			fieldObj.contact,
			fieldObj.contact_phone,
			fieldObj.contact_fax,
			fieldObj.contact_email,
			fieldObj.client_address
		);

		let kickoffFields = [];
		kickoffFields.push(
			fieldObj.last_contact_notes,
			fieldObj.ko,
			fieldObj.last_contact,
			fieldObj.kick_off_done
		);

		let shippingFields = [];
		shippingFields.push(fieldObj.ship_address, fieldObj.lift_gate_req);

		let result = (
			<ProjectForm
				key="project-main"
				colsize={12}
				title="Project Information"
				projectFields={projectFields}
				billingFields={billingFields}
				financeFields={financeFields}
				managementFields={managementFields}
				contactFields={contactFields}
				kickoffFields={kickoffFields}
				shippingFields={shippingFields}
			/>
		);

		return result;
	}

	/* PROGRAMING FORM BUILDERS: */
	buildProgramForm(routeData) {
		let fieldObj = {};
		fieldObj.userKeys = Object.keys(routeData.user);
		fieldObj.customerKeys = Object.keys(routeData.customer);
		fieldObj.contentKeys = Object.keys(routeData.content);
		fieldObj = this.buildProgramFormFoundataion(routeData, fieldObj);
		let result = <div />;

		switch (this.state.subsection) {
			case 'CONTENT':
				result = this.buildProgramContentForm(routeData, fieldObj);
				return result;
			case 'MODIFICATIONS':
				result = this.buildProgramModificationsForm(routeData, fieldObj);
				return result;
			case 'MAIN':
			default:
				result = this.buildProgramFeaturesForm(routeData, fieldObj);
				return result;
		}
	}

	buildProgramFormFoundataion(routeData, fieldObj) {
		fieldObj.industry = (
			<FormSelect
				colsize={12}
				key={`00-product-content`}
				dbView={this.state.dbView}
				humanLabel="Project Type"
				label={'industry'}
				valueArray={routeData.all_project_types}
				currentValue={routeData.content.industry}
				triggerFormValueChange={this.triggerFormValueChange}
				parentID={routeData.content.bronco.id_prefix}
			/>
		);

		fieldObj.userKeys.forEach((key, i) => {
			switch (key) {
				// half-width text areas:
				case 'user_name':
				case 'pin':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-user`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				default:
			}
		});

		fieldObj.customerKeys.forEach((key, i) => {
			switch (key) {
				// full-width dropdowns
				case 'screen_approval':
					fieldObj[key] = (
						<FormSelect
							colsize={6}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_screen_approvals}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// uniquly labelled full width dropdown:
				case 'industry':
					break;
				// half-width text input
				case 'completed_by':
					fieldObj[key] = (
						<FormSelect
							key={`${i}-product-cust`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Production Employee"
							label={key}
							currentValue={routeData.customer[key]}
							valueArray={routeData.all_production_employees}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'csm_name':
					fieldObj[key] = (
						<FormSelect
							key={`${i}-product-cust`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="CSM Employee"
							label={key}
							currentValue={routeData.customer[key]}
							valueArray={routeData.all_csm_employees}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// full-width text input with custom label:
				case 'project_id':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-cust`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Customer ID"
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'folder_name':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-cust`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Project Folder"
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// 1/2 width datepickers
				case 'project_completed':
					// case 'orig_proj_ship_date': // removed 10/26 on advice of Gene
					fieldObj[key] = (
						<FormDatePicker
							colsize={6}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							date={routeData.customer[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'online_upd_expire':
					fieldObj[key] = (
						<FormDatePicker
							colsize={6}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel="Expected Ship Date"
							label={key}
							date={routeData.customer[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'due_date':
					fieldObj[key] = (
						<FormDatePicker
							colsize={0}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel="Ship Date"
							label={key}
							date={routeData.customer[key]}
							triggerFormDateChange={this.triggerFormDateChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// 1/3 width bools
				case 'all_content_received':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={'Content Received'}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'tenants_entered':
				case 'on_hold':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// special disabled text input for salesperson:
				case 'salesperson':
					fieldObj[key] = (
						<FormSelect
							colsize={6}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_sales_persons}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
							isDisabled={true}
						/>
					);
					break;
				case 'group_':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_group_types}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'encl_ordered':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel="Custom Enclosure Hold"
							label={key}
							valueArray={routeData.all_enclosure_order_opts}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// text areas
				case 'status_notes':
				case 'features':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
							rows={10}
						/>
					);
					break;
				default:
			}
		});

		return fieldObj;
	}

	buildProgramFeaturesForm(routeData, fieldObj) {
		fieldObj.userKeys.forEach((key, i) => {
			switch (key) {
				// half-width text areas:
				case 'subscription_notes':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-product-user`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				case 'dsi_notes':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-product-user`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
							rows={10}
						/>
					);
					break;
				case 'spec_instructions':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-product-user`}
							dbView={this.state.dbView}
							humanLabel="Special Instructions (Client Visible)"
							label={key}
							value={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
							rows={10}
						/>
					);
					break;
				// dropdowns:
				case 'subscription_type':
					fieldObj[key] = (
						<FormSelect
							colsize={6}
							key={`${i}-product-user`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_subscription_types}
							currentValue={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;
				case 'update_type':
					fieldObj[key] = (
						<FormSelect
							colsize={6}
							key={`${i}-product-user`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_update_types_alpha}
							currentValue={routeData.user[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.user.bronco.id_prefix}
						/>
					);
					break;

				default:
			}
		});

		fieldObj.customerKeys.forEach((key, i) => {
			switch (key) {
				// half-width dropdowns:
				case 'wayfinding':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_wayfinding_types}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'phone':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_twilio_phone_types}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// two-thirds dropdowns:
				case 'bundle_package':
					fieldObj[key] = (
						<FormSelect
							colsize={6}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_channel_bundles}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				case 'multiple_bldg':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// full-width text areas
				case 'image_upload_desc':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				// 1/2 width text areas
				case 'multiple_bldg_notes':
				case 'wayfinding_desc':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-product-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
						/>
					);
					break;
				default:
			}
		});

		fieldObj.contentKeys.forEach((key, i) => {
			switch (key) {
				// 1/2 sized dropdowns:
				case 'screen_resolution':
					fieldObj[key] = (
						<FormSelect
							colsize={6}
							key={`${i}-product-content`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_screen_resolution}
							currentValue={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'template':
					fieldObj[key] = (
						<FormSelect
							colsize={8}
							key={`${i}-product-content`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_templates}
							currentValue={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'comp_bldg_display':
					fieldObj[key] = (
						<FormSelect
							colsize={8}
							key={`${i}-product-content`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_comp_bldg_display_types}
							currentValue={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				// 1/2 sized text areas:
				case 'ts_comments':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-product-content`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							rows={20}
						/>
					);
					break;
				case 'premier_url':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-content`}
							colsize={8}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				// 1/3 sized text fields:
				case 'latitude':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-content`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel={<span>Latitude - <a href="http://www.latlong.net" target="new">Link</a></span>}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'longitude':
				case 'zip_postal':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-content`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				// 1/6 sized bools:
				case 'stocks':
				case 'custom_style':
				case 'static':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-content`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ts_live':
					fieldObj[key] = (
						<FormBool
							colsize={8}
							key={`${i}-product-content`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'premier_on':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-content`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'traffic_display':
				case 'transit_display':
				case 'amenity_display':
					fieldObj[key] = (
						<div className="left">
							<ComboLabel
								value={routeData.content[key]}
								key={`${i}-product-content`}
								dbView={this.state.dbView}
								humanLabel={this.makeLabel(key)}
								label={key}
								triggerFormBoolChange={this.triggerFormBoolChange}
								parentID={routeData.content.bronco.id_prefix}
								width100={true}
							/>
						</div>
					);
					break;
				case 'amenity_zoom':
					fieldObj[key] = (
						<div className="right">
							<div className="simpleLabel">Amenity Zoom (1-20)</div>
							<ComboInput
								castToBool={this.castToBool}
								label={key}
								dbView={this.state.dbView}
								humanLabel={this.makeLabel(key)}
								indVar={routeData.content.amenity_display}
								indVarLabel="Amenity Display"
								inputType="text"
								triggerFormValueChange={this.triggerFormValueChange}
								parentID={routeData.content.bronco.id_prefix}
								value={routeData.content[key]}
								labelStackedOnTop={true}
								maxLength={true}
							/>
						</div>
					);
					break;
				case 'transit_u_rl':
					fieldObj[key] = (
						<div className="right">
							<div className="simpleLabel">Traffic URL</div>
							<ComboInput
								castToBool={this.castToBool}
								label={key}
								dbView={this.state.dbView}
								humanLabel={this.makeLabel(key)}
								indVar={routeData.content.transit_display}
								indVarLabel="Transit Display"
								inputType="text"
								triggerFormValueChange={this.triggerFormValueChange}
								parentID={routeData.content.bronco.id_prefix}
								value={routeData.content[key]}
								labelStackedOnTop={true}
								maxLength={true}
							/>
						</div>
					);
					break;
				case 'traffic_zoom':
					fieldObj[key] = (
						<div className="right">
							<div className="simpleLabel">Traffic Zoom (1-20)</div>
							<ComboInput
								castToBool={this.castToBool}
								label={key}
								dbView={this.state.dbView}
								humanLabel={this.makeLabel(key)}
								indVar={routeData.content.traffic_display}
								indVarLabel="Traffic Display"
								inputType="text"
								triggerFormValueChange={this.triggerFormValueChange}
								parentID={routeData.content.bronco.id_prefix}
								value={routeData.content[key]}
								labelStackedOnTop={true}
								maxLength={true}
							/>
						</div>
					);
					break;
				// A very special boolean because it shares name.
				case 'multiple_bldg':
					fieldObj.multiple_bldg_filter = (
						<FormBool
							colsize={6}
							key={`${i}-product-content`}
							dbView={this.state.dbView}
							humanLabel="Mult Blg Filter"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				default:
			}
		});

		let loginFields = [];
		loginFields.push(
			fieldObj.user_name,
			fieldObj.pin,
			fieldObj.project_id
		);

		let statusFields = [];
		statusFields.push(
			fieldObj.all_content_received,
			fieldObj.tenants_entered,
			fieldObj.on_hold,
			fieldObj.completed_by,
			fieldObj.csm_name,
			fieldObj.salesperson,
			fieldObj.screen_approval,
			// fieldObj.orig_proj_ship_date, // Removed by Gene 10/26/18
			fieldObj.online_upd_expire,
			fieldObj.due_date,
			fieldObj.project_completed,
			fieldObj.encl_ordered,
			fieldObj.industry,
			fieldObj.group_,
			fieldObj.folder_name,
			fieldObj.status_notes,
			fieldObj.features
		);

		let featureFields = [];
		featureFields.push(
			fieldObj.subscription_type,
			fieldObj.bundle_package,
			fieldObj.stocks,
			fieldObj.ts_live,
			fieldObj.premier_on,
			fieldObj.premier_url,
			<Col xs={12} key="content-featurecombo-0">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.amenity_display}
					inputChild={fieldObj.amenity_zoom}
				/>
			</Col>,
			<Col xs={12} key="content-featurecombo-1">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.traffic_display}
					inputChild={fieldObj.traffic_zoom}
				/>
			</Col>,
			fieldObj.latitude,
			fieldObj.longitude,
			fieldObj.zip_postal,
			<Col xs={12} key="content-featurecombo-2">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.transit_display}
					inputChild={fieldObj.transit_u_rl}
				/>
			</Col>,
			fieldObj.subscription_notes
		);

		let bldgButton =
			this.isBetterArray(routeData.building) &&
				routeData.building.length > 0 ? (
					<Col xs={6} key="bldg_btn">
						<Button onClick={this.toggleBuildingModal} className="button buildingList">
							Show Buildings
						</Button>
					</Col>
				) : (
					<Col xs={4} key="bldg_btn">
						<Button color="info" className="buildingList" onClick={
							(event) => {
								event.preventDefault();
								if (this.state.formChanged) {
									window.alert('Please save changes before creating new records.');
									return;
								}

								if (window.confirm('Create New Building Record?')) {
									this.toggleLoader();
									this.createOneBuilding().then(
										(success) => {
											let section = this.state.section;
											let subsection = this.state.subsection;
											this.setState(
												{ routeHolder: this.state.route },
												() => {
													return this.getRouteAndData(() => {
														this.setState({ section: section, subsection: subsection });
													});
												});
										},
										(err) => {
											this.toggleLoader();
											this.reportErr('Failed to create building');
										}
									);
								}
							}
						}>
							Add Building List
						</Button>
					</Col>
				);

		let featureFields2 = [];
		featureFields2.push(
			fieldObj.wayfinding,
			fieldObj.wayfinding_desc,
			fieldObj.image_upload_desc,
			fieldObj.multiple_bldg,
			fieldObj.multiple_bldg_filter,
			fieldObj.phone,
			fieldObj.multiple_bldg_notes,
			bldgButton
		);

		let setupFields = [];
		setupFields.push(
			fieldObj.screen_resolution,
			fieldObj.update_type,
			fieldObj.custom_style,
			fieldObj.template,
			fieldObj.ts_comments,
		);

		let setupFields2 = [];
		setupFields2.push(
			fieldObj.comp_bldg_display,
			fieldObj.static,
			fieldObj.dsi_notes,
			fieldObj.spec_instructions
		);

		let result = (
			<ProgramForm
				key="Program Form"
				colsize={12}
				subsection={this.state.subsection}
				title="PROGRAM FEATURES"
				section={this.state.section}
				changeSubsection={this.changeSubsection}
				loginFields={loginFields}
				statusFields={statusFields}
				featureFields={featureFields}
				featureFields2={featureFields2}
				setupFields={setupFields}
				setupFields2={setupFields2}
			/>
		);

		return result;
	}

	buildProgramContentForm(routeData, fieldObj) {
		fieldObj.contentKeys.forEach((key, i) => {
			switch (key) {
				// slideshow stuff:
				case 'main_logo_display':
					// Using COL for a lone bool on a line.
					fieldObj[key] = (
						<FormBool
							colsize={12}
							key={`${i}-product-slideshow`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'slide_show_full':
					fieldObj[key] = (
						<FormBool
							colsize={12}
							key={`${i}-product-slideshow`}
							dbView={this.state.dbView}
							humanLabel="Full Width"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'prop_scroll_msg':
					fieldObj[key] = (
						<FormBool
							colsize={12}
							key={`${i}-product-slideshow`}
							dbView={this.state.dbView}
							humanLabel="Scrolling Message"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'you_tube':
				case 'video_upload':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-slideshow`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ss_2_max_w':
				case 'ss_2_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-slideshow`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'main_logo_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-slideshow`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Logo Max H"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'main_logo_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-slideshow`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Logo Max W"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'attr_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-slideshow`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Slide Max W"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'attr_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-slideshow`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Slide Max H"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				// slideshow combos:
				case 'attract_images':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-slideshow`}
							dbView={this.state.dbView}
							humanLabel="Slideshow 1"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ss_1_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.attract_images}
							indVarLabel="AttractImages"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'slide_show_2':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-slideshow`}
							dbView={this.state.dbView}
							humanLabel="Slideshow 2"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ss_2_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.slide_show_2}
							indVarLabel="SlideShow2"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'main_logo_upload':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-slideshow`}
							dbView={this.state.dbView}
							humanLabel="Logo Upload"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'main_logo_type':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.main_logo_upload}
							indVarLabel="MainLogoUpload"
							inputType="select"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							valueArray={routeData.all_logo_types}
							maxLength={true}
						/>
					);
					break;

				// companies stuff:
				case 'combined':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-company`}
							dbView={this.state.dbView}
							humanLabel="Combined"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'comp_floor':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-company`}
							dbView={this.state.dbView}
							humanLabel="Floor"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'comp_bldg':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-company`}
							dbView={this.state.dbView}
							humanLabel="Building"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'comp_phone':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-company`}
							dbView={this.state.dbView}
							humanLabel="Phone"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'comp_image':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-company`}
							dbView={this.state.dbView}
							humanLabel="Image"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'comp_description':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-company`}
							dbView={this.state.dbView}
							humanLabel="Description"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'combined_but_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.combined}
							indVarLabel="Combined"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'comp_floor_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.comp_floor}
							indVarLabel="CompFloor"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'comp_bldg_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.comp_bldg}
							indVarLabel="CompBldg"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'comp_phone_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.comp_phone}
							indVarLabel="CompPhone"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'comp_image_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.comp_image}
							indVarLabel="CompImage"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'comp_descrip_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.comp_description}
							indVarLabel="CompDescription"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'comp_name_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-company`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Name Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'comp_suite_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-company`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Suite Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'comp_logo':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-company`}
							dbView={this.state.dbView}
							humanLabel="Logo"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'comp_image_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-company`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Image Max W"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'comp_image_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-company`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Image Max H"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'logo_max_h':
				case 'logo_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-company`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				// individuals form
				case 'ind_name_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-indv`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Name Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'ind_comp_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-indv`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Company Name"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'ind_suite_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-indv`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Suite Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'ind_title_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-indv`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Title Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'ind_image_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-indv`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Image Max W"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'ind_image_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-indv`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Image Max H"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'ind_ranking':
					fieldObj[key] = (
						<FormBool
							colsize={12}
							key={`${i}-product-indv`}
							dbView={this.state.dbView}
							humanLabel="Ranking"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ind_phone':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-indv`}
							dbView={this.state.dbView}
							humanLabel="Phone"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ind_floor':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-indv`}
							dbView={this.state.dbView}
							humanLabel="Floor"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'indi_building':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-indv`}
							dbView={this.state.dbView}
							humanLabel="Building"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ind_image':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-indv`}
							dbView={this.state.dbView}
							humanLabel="Image"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ind_custom_1':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-indv`}
							dbView={this.state.dbView}
							humanLabel="Custom 1"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ind_custom_2':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-indv`}
							dbView={this.state.dbView}
							humanLabel="Custom 2"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'ind_memo':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-indv`}
							dbView={this.state.dbView}
							humanLabel="Memo"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'ind_phone_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.ind_phone}
							indVarLabel="IndPhone"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'ind_floor_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.ind_floor}
							indVarLabel="IndFloor"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'indi_building_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.indi_building}
							indVarLabel="IndBuilding"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'ind_image_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.ind_image}
							indVarLabel="IndImage"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'ind_custom_1_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.ind_custom_1}
							indVarLabel="IndCustom1"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'ind_custom_2_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.ind_custom_2}
							indVarLabel="IndCustom2"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'ind_memo_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.ind_memo}
							indVarLabel="IndMemo"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				// property inputs:
				case 'property_display':
					fieldObj[key] = (
						<FormSelect
							colsize={8}
							key={`${i}-product-prop`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_property_display_types}
							currentValue={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'prop_name_font':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-prop`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Font Size"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'prop_logo_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-prop`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Logo Max W"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'prop_logo_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-prop`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Logo Max H"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'prop_mgmt_logo':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-prop`}
							dbView={this.state.dbView}
							humanLabel="Mgmt Logo"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'prop_lsg_logo':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-prop`}
							dbView={this.state.dbView}
							humanLabel="Lease Logo"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'prop_leasing_5':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-prop`}
							dbView={this.state.dbView}
							humanLabel="Line 5"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'prop_emergency':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-prop`}
							dbView={this.state.dbView}
							humanLabel="Emergency Contact"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'prop_descrip':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-prop`}
							dbView={this.state.dbView}
							humanLabel="Description"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'prop_emergency_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.prop_emergency}
							indVarLabel="PropEmergency"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'prop_descrip_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.prop_descrip}
							indVarLabel="PropDescrip"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				// amenities inputs
				case 'amen_name_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-amen`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Name Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'amen_location_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-amen`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Location Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'amen_description_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-amen`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Description Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'amen_phone_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-amen`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Phone Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'amenity_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-amen`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Max W"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'amenity_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-amen`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Max H"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'amen_type':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="Type"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_onsite':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="Onsite"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_address':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="Address"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_city':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="City"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_state':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="State"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_zip':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="Zip"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_suite':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="Suite (Map)"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_bldg':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="Bldg (Map)"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_qr_code':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-amen`}
							dbView={this.state.dbView}
							humanLabel="QR Code"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_custom_1':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Custom 1"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_custom_2':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Custom 2"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_photo':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Image"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'amen_custom_1_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.amen_custom_1}
							indVarLabel="AmenCustom1"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'amen_custom_2_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.amen_custom_2}
							indVarLabel="AmenCustom2"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'amen_photo_file_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.amen_photo}
							indVarLabel="AmenPhoto"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				// space inputs
				case 'space_suite_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-space`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Suite Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'space_cost_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-space`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Cost Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'space_size_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-space`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Size Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'space_avail_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-space`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Availability Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'space_floorplan':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-space`}
							dbView={this.state.dbView}
							humanLabel="Floorplan"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'space_floor':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-space`}
							dbView={this.state.dbView}
							humanLabel="Floor"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'space_bldg':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-space`}
							dbView={this.state.dbView}
							humanLabel="Building"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'announce_bldg':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-anno`}
							dbView={this.state.dbView}
							humanLabel="Bldg (Map)"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'announce_suite':
					fieldObj[key] = (
						<FormBool
							colsize={4}
							key={`${i}-product-anno`}
							dbView={this.state.dbView}
							humanLabel="Suite (Map)"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'announce_image':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-anno`}
							dbView={this.state.dbView}
							humanLabel="Image"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'announce_label':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-anno`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Name Label"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'announce_image_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.announce_image}
							indVarLabel="AnnounceImage"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'announce_image_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-anno`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Image Max W"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'announce_image_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-anno`}
							colsize={6}
							dbView={this.state.dbView}
							humanLabel="Image Max H"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				// entering list12 hell:
				// case 'list_12_name': TODO DETERMINE IF ITS NEEDED.
				case 'list_12_text_1':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_text_2':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Text 2"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_text_3':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Text 3"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_text_4':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Text 4"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_text_5':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Text 5"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_text_6':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Text 6"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_text_7':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Text 7"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_text_8':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Text 8"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_boolean_1':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Boolean 1"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_boolean_2':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Boolean 2"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_date_1':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Date 1"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_date_2':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Date 2"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_number_1':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Number 1"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_number_2':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Number 2"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_memo_1':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Memo"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_image_name':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel="Image"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'list_12_image_max_w':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-l12`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Image Max W"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'list_12_image_max_h':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-l12`}
							colsize={4}
							dbView={this.state.dbView}
							humanLabel="Image Max H"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_text_label_1':
					fieldObj[key] = (
						<FormText
							key={`${i}-product-l12`}
							colsize={12}
							dbView={this.state.dbView}
							humanLabel="Name Label (Text 1)"
							label={key}
							value={routeData.content[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_text_label_2':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_text_2}
							indVarLabel="List12Text2"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_text_label_3':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_text_3}
							indVarLabel="List12Text3"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_text_label_4':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_text_4}
							indVarLabel="List12Text4"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_text_label_5':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_text_5}
							indVarLabel="List12Text5"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_text_label_6':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_text_6}
							indVarLabel="List12Text6"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_text_label_7':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_text_7}
							indVarLabel="List12Text7"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_text_label_8':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_text_8}
							indVarLabel="List12Text8"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_bool_label_1':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_boolean_1}
							indVarLabel="List12Boolean1"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_bool_label_2':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_boolean_2}
							indVarLabel="List12Boolean2"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_date_label_1':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_date_1}
							indVarLabel="List12Date1"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_date_label_2':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_date_2}
							indVarLabel="List12Date2"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_num_label_1':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_number_1}
							indVarLabel="List12Number1"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_num_label_2':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_number_2}
							indVarLabel="List12Number2"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_memo_label_1':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_memo_1}
							indVarLabel="List12Memo1"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_image_label_1':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12_image_name}
							indVarLabel="List12ImageName"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				// pdf forms:
				case 'pdf_upload':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-pdf`}
							dbView={this.state.dbView}
							humanLabel="PDF 1 Upload"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'pdf_upload_2':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-pdf`}
							dbView={this.state.dbView}
							humanLabel="PDF 2 Upload"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'pdf_upload_3':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-pdf`}
							dbView={this.state.dbView}
							humanLabel="PDF 3 Upload"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'pdf_upload_4':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-pdf`}
							dbView={this.state.dbView}
							humanLabel="PDF 4 Upload"
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				case 'pdf_upload_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.pdf_upload}
							indVarLabel="PdfUpload"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'pdf_2_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.pdf_upload_2}
							indVarLabel="PdfUpload2"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'pdf_3_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.pdf_upload_3}
							indVarLabel="PdfUpload3"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'pdf_4_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.pdf_upload_4}
							indVarLabel="PdfUpload4"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				// controller combo labels
				case 'companies':
				case 'individuals':
				case 'property':
				case 'space':
				case 'amenities':
				case 'announcements':
				case 'list_12':
					fieldObj[key] = (
						<ComboLabel
							value={routeData.content[key]}
							key={`${i}-product-controller`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							triggerFormBoolChange={this.triggerFormBoolChange}
							parentID={routeData.content.bronco.id_prefix}
						/>
					);
					break;
				// combo inputs
				case 'comp_but_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.companies}
							indVarLabel="Companies"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'ind_but_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.individuals}
							indVarLabel="Individuals"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'prop_but_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.property}
							indVarLabel="Property"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'lease_but_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.space}
							indVarLabel="Space"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'amen_but_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.amenities}
							indVarLabel="Amenities"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'announce_but_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.announcements}
							indVarLabel="Announcements"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				case 'l_12_but_label':
					fieldObj[key] = (
						<ComboInput
							castToBool={this.castToBool}
							label={key}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							indVar={routeData.content.list_12}
							indVarLabel="List12"
							inputType="text"
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.content.bronco.id_prefix}
							value={routeData.content[key]}
							maxLength={true}
						/>
					);
					break;
				default:
			}
		});

		let contentController = [];
		contentController.push(
			<ProgramCombo
				key="content-controller-0"
				controller={true}
				localFocus="SLIDESHOW"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				inputChild={
					<Button
						onClick={(event) => {
							event.preventDefault();
						}}
						className="content-button alwaysOn"
					>
						Slideshow / Logo / Message
					</Button>
				}
			/>,
			<ProgramCombo
				key="content-controller-1"
				controller={true}
				localFocus="COMPANIES"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				labelChild={fieldObj.companies}
				inputChild={fieldObj.comp_but_label}
			/>,
			<ProgramCombo
				key="content-controller-2"
				controller={true}
				localFocus="INDIVIDUALS"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				labelChild={fieldObj.individuals}
				inputChild={fieldObj.ind_but_label}
			/>,
			<ProgramCombo
				key="content-controller-3"
				controller={true}
				localFocus="PROPERTY"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				labelChild={fieldObj.property}
				inputChild={fieldObj.prop_but_label}
			/>,
			<ProgramCombo
				key="content-controller-4"
				controller={true}
				localFocus="AMENITIES"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				labelChild={fieldObj.amenities}
				inputChild={fieldObj.amen_but_label}
			/>,
			<ProgramCombo
				key="content-controller-5"
				controller={true}
				localFocus="SPACE"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				labelChild={fieldObj.space}
				inputChild={fieldObj.lease_but_label}
			/>,
			<ProgramCombo
				key="content-controller-6"
				controller={true}
				localFocus="ANNOUNCEMENTS"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				labelChild={fieldObj.announcements}
				inputChild={fieldObj.announce_but_label}
			/>,
			<ProgramCombo
				key="content-controller-7"
				controller={true}
				localFocus="LIST12"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				labelChild={fieldObj.list_12}
				inputChild={fieldObj.l_12_but_label}
			/>,
			<ProgramCombo
				key="content-controller-10"
				controller={true}
				localFocus="PDF"
				comboFocus={this.state.comboFocus}
				changeComboFocus={this.changeComboFocus}
				inputChild={
					<Button
						onClick={(event) => {
							event.preventDefault();
						}}
						className="content-button"
					>
						PDF Upload
					</Button>
				}
			/>
		);

		let loginFields = [];
		loginFields.push(
			fieldObj.user_name,
			fieldObj.pin,
			fieldObj.project_id,
			<QuestionField
				qNum="1"
				key="q1"
				prob="Where will the project folders live?"
			/>
		);

		let statusFields = [];
		statusFields.push(
			fieldObj.all_content_received,
			fieldObj.tenants_entered,
			fieldObj.on_hold,
			fieldObj.completed_by,
			fieldObj.csm_name,
			fieldObj.salesperson,
			fieldObj.screen_approval,
			// fieldObj.orig_proj_ship_date, // Removed by Gene 10/26/18
			fieldObj.online_upd_expire,
			fieldObj.due_date,
			fieldObj.project_completed,
			fieldObj.encl_ordered,
			fieldObj.industry,
			fieldObj.group_,
			fieldObj.status_notes,
			fieldObj.features
		);

		let slideshow1Form = [];
		let slideshow2Form = [];

		slideshow1Form.push(
			fieldObj.main_logo_display,
			<Col xs={12} key="content-slideshowcombo-1">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.main_logo_upload}
					inputChild={fieldObj.main_logo_type}
				/>
			</Col>,
			fieldObj.main_logo_max_w,
			fieldObj.main_logo_max_h,
			fieldObj.prop_scroll_msg
		);

		slideshow2Form.push(
			<Col xs={12} key="content-slideshowcombo-2">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.attract_images}
					inputChild={fieldObj.ss_1_label}
				/>
			</Col>,
			fieldObj.slide_show_full,
			fieldObj.attr_max_w,
			fieldObj.attr_max_h,
			fieldObj.you_tube,
			fieldObj.video_upload,
			<Col xs={12} key="content-slideshowcombo-3">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.slide_show_2}
					inputChild={fieldObj.ss_2_label}
				/>
			</Col>,
			fieldObj.ss_2_max_w,
			fieldObj.ss_2_max_h
		);

		let companiesForm = [];

		companiesForm.push(
			<Col xs={12} key="content-compcombo-0">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.combined}
					inputChild={fieldObj.combined_but_label}
				/>
			</Col>,
			fieldObj.comp_name_label,
			fieldObj.comp_suite_label,
			<Col xs={12} key="content-compcombo-1">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.comp_floor}
					inputChild={fieldObj.comp_floor_label}
				/>
			</Col>,
			<Col xs={12} key="content-compcombo-2">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.comp_bldg}
					inputChild={fieldObj.comp_bldg_label}
				/>
			</Col>,
			<Col xs={12} key="content-compcombo-3">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.comp_phone}
					inputChild={fieldObj.comp_phone_label}
				/>
			</Col>,
			fieldObj.comp_logo,
			fieldObj.logo_max_w,
			fieldObj.logo_max_h,
			<Col xs={12} key="content-compcombo-4">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.comp_image}
					inputChild={fieldObj.comp_image_label}
				/>
			</Col>,
			<Col xs={4} key="content-layout-0" />,
			fieldObj.comp_image_max_w,
			fieldObj.comp_image_max_h,
			<Col xs={12} key="content-compcombo-5">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.comp_description}
					inputChild={fieldObj.comp_descrip_label}
				/>
			</Col>
		);

		let individualsForm = [];
		individualsForm.push(
			fieldObj.ind_name_label,
			fieldObj.ind_comp_label,
			fieldObj.ind_suite_label,
			fieldObj.ind_title_label,
			<Col xs={12} key="content-indcombo-0">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.ind_phone}
					inputChild={fieldObj.ind_phone_label}
				/>
			</Col>,
			<Col xs={12} key="content-indcombo-1">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.ind_floor}
					inputChild={fieldObj.ind_floor_label}
				/>
			</Col>,
			fieldObj.ind_ranking,
			<Col xs={12} key="content-indcombo-2">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.indi_building}
					inputChild={fieldObj.indi_building_label}
				/>
			</Col>,
			<Col xs={12} key="content-indcombo-3">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.ind_image}
					inputChild={fieldObj.ind_image_label}
				/>
			</Col>,
			<Col xs={4} key="content-layout-0" />,
			fieldObj.ind_image_max_w,
			fieldObj.ind_image_max_h,
			<Col xs={12} key="content-indcombo-4">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.ind_custom_1}
					inputChild={fieldObj.ind_custom_1_label}
				/>
			</Col>,
			<Col xs={12} key="content-indcombo-5">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.ind_custom_2}
					inputChild={fieldObj.ind_custom_2_label}
				/>
			</Col>,
			<Col xs={12} key="content-indcombo-6">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.ind_memo}
					inputChild={fieldObj.ind_memo_label}
				/>
			</Col>
		);

		let propertyForm = [];
		propertyForm.push(
			fieldObj.property_display,
			fieldObj.prop_name_font,
			fieldObj.prop_mgmt_logo,
			fieldObj.prop_lsg_logo,
			<Col xs={4} key="content-prop-layout-0" />,
			fieldObj.prop_logo_max_w,
			fieldObj.prop_logo_max_h,
			<Col xs={12} key="content-propcombo-1">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.prop_emergency}
					inputChild={fieldObj.prop_emergency_label}
				/>
			</Col>,
			fieldObj.prop_leasing_5,
			<Col xs={12} key="content-propcombo-2">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.prop_descrip}
					inputChild={fieldObj.prop_descrip_label}
				/>
			</Col>
		);

		let amenitiesForm = [];
		amenitiesForm.push(
			fieldObj.amen_name_label,
			fieldObj.amen_location_label,
			fieldObj.amen_phone_label,
			<Col xs={12} key="content-amencombo-0">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.amen_photo}
					inputChild={fieldObj.amen_photo_file_label}
				/>
			</Col>,
			fieldObj.amenity_max_h,
			fieldObj.amenity_max_w,
			fieldObj.amen_description_label,
			fieldObj.amen_type,
			fieldObj.amen_onsite,
			fieldObj.amen_address,
			fieldObj.amen_city,
			fieldObj.amen_state,
			fieldObj.amen_zip,
			fieldObj.amen_suite,
			fieldObj.amen_bldg,
			<Col xs={12} key="content-amencombo-1">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.amen_custom_1}
					inputChild={fieldObj.amen_custom_1_label}
				/>
			</Col>,
			<Col xs={12} key="content-amencombo-2">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.amen_custom_2}
					inputChild={fieldObj.amen_custom_2_label}
				/>
			</Col>,
			fieldObj.amen_qr_code
		);

		let spaceForm = [];
		spaceForm.push(
			fieldObj.space_suite_label,
			fieldObj.space_size_label,
			fieldObj.space_cost_label,
			fieldObj.space_avail_label,
			fieldObj.space_floor,
			fieldObj.space_bldg,
			fieldObj.space_floorplan
		);

		let announcementsForm = [];
		announcementsForm.push(
			fieldObj.announce_label,
			fieldObj.announce_suite,
			fieldObj.announce_bldg,
			<Col xs={12} key="content-annocombo-0">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.announce_image}
					inputChild={fieldObj.announce_image_label}
				/>
			</Col>,
			fieldObj.announce_image_max_w,
			fieldObj.announce_image_max_h
		);

		let list12Form = [];
		list12Form.push(
			fieldObj.l_12_text_label_1,
			<Col xs={12} key="content-list12-1">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_text_2}
					inputChild={fieldObj.l_12_text_label_2}
				/>
			</Col>,
			<Col xs={12} key="content-list12-2">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_text_3}
					inputChild={fieldObj.l_12_text_label_3}
				/>
			</Col>,
			<Col xs={12} key="content-list12-3">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_text_4}
					inputChild={fieldObj.l_12_text_label_4}
				/>
			</Col>,
			<Col xs={12} key="content-list12-4">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_text_5}
					inputChild={fieldObj.l_12_text_label_5}
				/>
			</Col>,
			<Col xs={12} key="content-list12-5">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_text_6}
					inputChild={fieldObj.l_12_text_label_6}
				/>
			</Col>,
			<Col xs={12} key="content-list12-6">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_text_7}
					inputChild={fieldObj.l_12_text_label_7}
				/>
			</Col>,
			<Col xs={12} key="content-list12-7">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_text_8}
					inputChild={fieldObj.l_12_text_label_8}
				/>
			</Col>,
			<Col xs={12} key="content-list12-8">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_boolean_1}
					inputChild={fieldObj.l_12_bool_label_1}
				/>
			</Col>,
			<Col xs={12} key="content-list12-9">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_boolean_2}
					inputChild={fieldObj.l_12_bool_label_2}
				/>
			</Col>,
			<Col xs={12} key="content-list12-10">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_date_1}
					inputChild={fieldObj.l_12_date_label_1}
				/>
			</Col>,
			<Col xs={12} key="content-list12-11">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_date_2}
					inputChild={fieldObj.l_12_date_label_2}
				/>
			</Col>,
			<Col xs={12} key="content-list12-12">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_number_1}
					inputChild={fieldObj.l_12_num_label_1}
				/>
			</Col>,
			<Col xs={12} key="content-list12-13">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_number_2}
					inputChild={fieldObj.l_12_num_label_2}
				/>
			</Col>,
			<Col xs={12} key="content-list12-14">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_memo_1}
					inputChild={fieldObj.l_12_memo_label_1}
				/>
			</Col>,
			<Col xs={12} key="content-list12-15">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.list_12_image_name}
					inputChild={fieldObj.l_12_image_label_1}
				/>
			</Col>,
			<Col xs={4} key="content-list12-layout-0" />,
			fieldObj.list_12_image_max_w,
			fieldObj.list_12_image_max_h
		);

		let pdfForm = [];
		pdfForm.push(
			<Col xs={12} key="content-pdf-0">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.pdf_upload}
					inputChild={fieldObj.pdf_upload_label}
				/>
			</Col>,
			<Col xs={12} key="content-pdf-1">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.pdf_upload_2}
					inputChild={fieldObj.pdf_2_label}
				/>
			</Col>,
			<Col xs={12} key="content-pdf-2">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.pdf_upload_3}
					inputChild={fieldObj.pdf_3_label}
				/>
			</Col>,
			<Col xs={12} key="content-pdf-3">
				<ProgramCombo
					controller={false}
					changeComboFocus={() => { }}
					labelChild={fieldObj.pdf_upload_4}
					inputChild={fieldObj.pdf_4_label}
				/>
			</Col>
		);

		let result = (
			<ProgramForm
				key="Program Form"
				colsize={12}
				subsection={this.state.subsection}
				title="PROGRAM FEATURES"
				section={this.state.section}
				changeSubsection={this.changeSubsection}
				comboFocus={this.state.comboFocus}
				loginFields={loginFields}
				statusFields={statusFields}
				contentController={contentController}
				slideshow1Form={slideshow1Form}
				slideshow2Form={slideshow2Form}
				companiesForm={companiesForm}
				individualsForm={individualsForm}
				propertyFrom={propertyForm}
				amenitiesForm={amenitiesForm}
				spaceForm={spaceForm}
				announcementsForm={announcementsForm}
				list12Form={list12Form}
				pdfForm={pdfForm}
			/>
		);

		return result;
	}

	showSelectedRecord(e) {
		let record = e.target;
		if (document.querySelector('.activeBtn')) {
			document.querySelector('.activeBtn').classList.remove('activeBtn');
		}
		record.classList.add('activeBtn');
		this.setState({
			activeRecord: record.dataset.id
		}, function () {
			let nextData = Object.assign({}, this.state.dbData.data);
			let nextProgramForm = this.buildProgramForm(nextData);
			let nextHardwareForm = this.buildHardwareForm(nextData);
			this.setState({
				programForm: nextProgramForm,
				hardwareForm: nextHardwareForm
			});
		});
	}

	newModRecord(e) {
		if (this.state.formChanged) {
			window.alert('Please save changes before creating new records.');
			return;
		}

		if (window.confirm('Create New Modification Record?')) {
			this.setState({ loading: true });
			let dataObj = {};
			dataObj.project = this.state.dbData.data.customer.project_id;

			let plainDate = moment();
			let fmtDate = plainDate.format('ddd MMM DD HH:mm:ss UTC YYYY');
			dataObj.call_date = fmtDate;

			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersModifications/`;

			let postObj = JSON.stringify(dataObj);
			let authHeaders = this.md5PostXAuthHeaders();

			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					return this.setState({
						error: `${error} -- Please check your network connection.`,
						loading: false
					});
				})
				.then((res) => {
					this.handleGetRouteFromSearch(this.state.route, () => {
						this.setState({
							section: 'PROGRAM',
							subsection: 'MODIFICATIONS'
						}, () => {
							let nextData = Object.assign({}, this.state.dbData.data);
							let nextProgramForm = this.buildProgramForm(nextData);
							this.setState({
								programForm: nextProgramForm,
								loading: false
							});
						});
					});
				});
		}
	}

	toggleLoader() {
		this.setState({ loading: !this.state.loading });
	}

	toggleBldgBatch() {
		this.setState({ showBldgBatch: !this.state.showBldgBatch });
	}

	togglePCBatch() {
		this.setState({ showPCBatch: !this.state.showPCBatch }, () => {
			let nextHardwareForm = this.buildHardwareForm(this.state.dbData.data);
			this.setState({ hardwareForm: nextHardwareForm });
		});
	}

	toggleMonitorBatch() {
		this.setState({ showMonitorBatch: !this.state.showMonitorBatch }, () => {
			let nextHardwareForm = this.buildHardwareForm(this.state.dbData.data);
			this.setState({ hardwareForm: nextHardwareForm });
		});
	}

	newBuildingRecord(e) {
		e.preventDefault();
		if (this.state.formChanged) {
			window.alert('Please save changes before creating new records.');
			return;
		}

		this.toggleBldgBatch();
	}

	newModRecordFromQuote(e, quote) {
		if (this.state.formChanged) {
			window.alert('Please save changes before creating new records.');
			return;
		}

		if (window.confirm('Create New Modification Record from this Quote?')) {
			this.setState({ loading: true });
			let dataObj = {};
			dataObj.project = this.state.dbData.data.customer.project_id;

			let plainDate = moment();
			let fmtDate = plainDate.format('ddd MMM DD HH:mm:ss UTC YYYY');

			dataObj.call_date = fmtDate;
			dataObj.dsi_point_person = quote.tsi_contact;
			dataObj.contact_name = quote.contact_name;
			dataObj.contact_phone = quote.contact_phone;
			dataObj.contact_email = quote.contact_email;
			dataObj.description = quote.product_1_desc;
			dataObj.cost = quote.product_1_price;

			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersModifications/`;

			let postObj = JSON.stringify(dataObj);
			let authHeaders = this.md5PostXAuthHeaders();

			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					return this.setState({
						error: `${error} -- Please check your network connection.`,
						loading: false
					});
				})
				.then((res) => {
					this.handleGetRouteFromSearch(this.state.route, () => {
						this.setState({
							section: 'PROGRAM',
							subsection: 'MODIFICATIONS'
						}, () => {
							let nextData = Object.assign({}, this.state.dbData.data);
							let nextProgramForm = this.buildProgramForm(nextData);
							this.setState({
								programForm: nextProgramForm,
								loading: false
							});
						});
					});
				});
		}
	}

	newModQuote(e) {
		if (this.state.formChanged) {
			window.alert('Please save changes before creating new records.');
			return;
		}

		if (window.confirm('Create New Modification Quote?')) {
			this.setState({ loading: true });
			let dataObj = {};
			dataObj.project_id = this.state.dbData.data.customer.project_id;

			let plainDate = moment();
			let fmtDate = plainDate.format('ddd MMM DD HH:mm:ss UTC YYYY');
			dataObj.create_date = fmtDate;

			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersModquotes/`;

			let postObj = JSON.stringify(dataObj);
			let authHeaders = this.md5PostXAuthHeaders();

			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					return this.setState({
						error: `${error} -- Please check your network connection.`,
						loading: false
					});
				})
				.then((res) => {
					this.handleGetRouteFromSearch(this.state.route, () => {
						this.setState({
							section: 'PROGRAM',
							subsection: 'MODIFICATIONS'
						}, () => {
							let nextData = Object.assign({}, this.state.dbData.data);
							let nextProgramForm = this.buildProgramForm(nextData);
							this.setState({
								programForm: nextProgramForm,
								loading: false
							});
						});
					});
				});
		}
	}

	newSvcRecord(e) {
		if (this.state.formChanged) {
			window.alert('Please save changes before creating new records.');
			return;
		}

		if (window.confirm('Create New Service Record?')) {
			this.setState({ loading: true });
			let dataObj = {};
			dataObj.project = this.state.dbData.data.customer.project_id;

			let plainDate = moment();
			let fmtDate = plainDate.format('ddd MMM DD HH:mm:ss UTC YYYY');
			dataObj.call_date = fmtDate;

			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersService/`;

			let postObj = JSON.stringify(dataObj);
			let authHeaders = this.md5PostXAuthHeaders();

			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					return this.setState({
						error: `${error} -- Please check your network connection.`,
						loading: false
					});
				})
				.then((res) => {
					this.handleGetRouteFromSearch(this.state.route, () => {
						this.setState({
							section: 'HARDWARE',
							subsection: 'SERVICE_CALLS'
						}, () => {
							let nextData = Object.assign({}, this.state.dbData.data);
							let nextHardwareForm = this.buildHardwareForm(nextData);
							this.setState({
								hardwareForm: nextHardwareForm,
								loading: false
							});
						});
					});
				});
		}
	}

	newSvcQuote(e) {
		if (this.state.formChanged) {
			window.alert('Please save changes before creating new records.');
			return;
		}

		if (window.confirm('Create New Service Quote?')) {
			this.setState({ loading: true });
			let dataObj = {};
			dataObj.project_id = this.state.dbData.data.customer.project_id;

			let plainDate = moment();
			let fmtDate = plainDate.format('ddd MMM DD HH:mm:ss UTC YYYY');
			dataObj.create_date = fmtDate;

			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersSvcQuotes/`;

			let postObj = JSON.stringify(dataObj);
			let authHeaders = this.md5PostXAuthHeaders();

			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					return this.setState({
						error: `${error} -- Please check your network connection.`,
						loading: false
					});
				})
				.then((res) => {
					this.handleGetRouteFromSearch(this.state.route, () => {
						this.setState({
							section: 'HARDWARE',
							subsection: 'SERVICE_CALLS'
						}, () => {
							let nextData = Object.assign({}, this.state.dbData.data);
							let nextHardwareForm = this.buildHardwareForm(nextData);
							this.setState({
								hardwareForm: nextHardwareForm,
								loading: false
							});
						});
					});
				});
		}
	}

	buildProgramModificationsForm(routeData, fieldObj) {
		let modElms = [];
		let qrsProps = {
			activeID: this.state.activeMod,
			activeIDKey: 'activeMod',
			activeType: this.state.activeModType,
			activeTypeKey: 'activeModType',
			buildRecordForm: this.buildModRecordForm,
			buildQuoteForm: this.buildModQuoteForm,
			newRecordFromQuote: this.newModRecordFromQuote,
			newRecord: this.newModRecord,
			newQuote: this.newModQuote,
			mixedArray: this.state.modRecords,
			flavor: 'mod',
			setNewActiveRecord: this.changeActiveItem
		};

		let modElm = QuoteRecordSelector(qrsProps);
		modElms.push(modElm);

		let loginFields = [];
		loginFields.push(
			fieldObj.user_name,
			fieldObj.pin,
			fieldObj.project_id,
			<QuestionField
				qNum="1"
				key="q1"
				prob="Where will the project folders live?"
			/>
		);

		let statusFields = [];
		statusFields.push(
			fieldObj.all_content_received,
			fieldObj.tenants_entered,
			fieldObj.on_hold,
			fieldObj.completed_by,
			fieldObj.csm_name,
			fieldObj.salesperson,
			fieldObj.screen_approval,
			// fieldObj.orig_proj_ship_date, // Removed by Gene 10/26/18
			fieldObj.online_upd_expire,
			fieldObj.due_date,
			fieldObj.project_completed,
			fieldObj.encl_ordered,
			fieldObj.industry,
			fieldObj.group_,
			fieldObj.status_notes,
			fieldObj.features
		);

		let result = (
			<ProgramForm
				key="Program Form"
				colsize={12}
				subsection={this.state.subsection}
				title="PROGRAM FEATURES"
				section={this.state.section}
				changeSubsection={this.changeSubsection}
				comboFocus={this.state.comboFocus}
				loginFields={loginFields}
				statusFields={statusFields}
				modElms={modElms}
			/>
		);

		return result;
	}

	buildHardwareForm(routeData) {
		switch (this.state.subsection) {
			case 'NEW_ORDERS':
				return this.buildNewOrderForm(routeData);
			case 'SERVICE_CALLS':
				return this.buildServiceCallForm(routeData);
			case 'POS':
				return this.buildPurchaseOrderForm(routeData);
			case 'MAIN':
			default:
				return this.buildSupportSpecForm(routeData);
		}
	}

	resetDataOnModalClose() {
		this.setHardwareDuplicationModal(false);
		this.updateDupTargetAndType(false, false);
		this.forceFormChange();
	}

	makeDupModal() {
		if (!this.state.showHardwareDuplication) {
			return '';
		}

		let dupFunc;
		if (this.state.dupTargetType === 'PC') {
			dupFunc = this.duplicateOnePC;
		}

		if (this.state.dupTargetType === 'Monitor') {
			dupFunc = this.duplicateOneMonitor;
		}

		if (!dupFunc) {
			return (
				<Fragment>
					<Modal
						isOpen={this.state.showHardwareDuplication}
						toggle={() => {
							this.resetDataOnModalClose();
							this.forceFormChange();
						}}
						size="lg"
					>
						<ModalHeader className="h2">ERROR:</ModalHeader>
						<ModalBody>
							Expected dupTargetType to equal PC or Monitor, recieved: {this.state.dupTargetType}
						</ModalBody>
					</Modal>
				</Fragment>
			);
		}

		if (!this.state.dupTarget) {
			return (
				<Fragment>
					<Modal
						isOpen={this.state.showHardwareDuplication}
						toggle={() => {
							this.resetDataOnModalClose();
							this.forceFormChange();
						}}
						size="lg"
					>
						<ModalHeader className="h2">ERROR:</ModalHeader>
						<ModalBody>
							Expected dupTarget to have be truthy, recieved: {this.state.dupTarget}
						</ModalBody>
					</Modal>
				</Fragment>
			);
		}

		let inputID = `${this.state.dupTargetType.toLowerCase()}-duplicate`;
		return (
			<Fragment>
				<Modal
					isOpen={this.state.showHardwareDuplication}
					toggle={() => {
						this.resetDataOnModalClose();
						this.forceFormChange();
					}}
					size="lg"
				>
					<ModalHeader className="h2">{`Duplicate ${this.state.dupTargetType} Record`}</ModalHeader>
					<ModalBody>
						<div className="padded-batch">
							<BatchUploader
								batchFunc={() => {
									return dupFunc(this.state.dupTarget);
								}}
								inputID={inputID}
								inputName={inputID}
								show={true}
								toggle={() => {
									this.resetDataOnModalClose();
									this.forceFormChange();
								}}
								loader={this.toggleLoader}
								modalToggle={false}
								resetPage={() => {
									return this.batchReset(this.state.section, this.state.subsection, this.state.route);
								}}
								reportErr={this.reportErr}
							/>
						</div>
					</ModalBody>
					<ModalFooter></ModalFooter>
				</Modal>
			</Fragment>
		);
	}

	buildSupportSpecForm(routeData) {
		let pcModelOptions = [];
		let warrOptions = [];
		let monModelOptions = [];
		let exOptions = [];
		let orientOptions = [];
		let updateOptions = [];
		let tsOptions = [];
		let installOptions = [];

		routeData.all_pc_model_types.forEach((option, i) => {
			if (i === 0) {
				pcModelOptions.push(
					<option key="pc-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			pcModelOptions.push(
				<option key={`pc-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_warranty_types.forEach((option, i) => {
			if (i === 0) {
				warrOptions.push(
					<option key="warr-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			warrOptions.push(
				<option key={`warr-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_monitor_model_types.forEach((option, i) => {
			if (i === 0) {
				monModelOptions.push(
					<option key="mon-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			monModelOptions.push(
				<option key={`mon-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_update_types.forEach((option, i) => {
			if (i === 0) {
				updateOptions.push(
					<option key="update-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			updateOptions.push(
				<option key={`update-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_ts_admin_versions.forEach((option, i) => {
			if (i === 0) {
				tsOptions.push(
					<option key="ts-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			tsOptions.push(
				<option key={`ts-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_exit_methods.forEach((option, i) => {
			if (i === 0) {
				exOptions.push(
					<option key="exit-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			exOptions.push(
				<option key={`exit-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_installation_types.forEach((option, i) => {
			if (i === 0) {
				installOptions.push(
					<option key="install-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			installOptions.push(
				<option key={`install-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_orientations.forEach((option, i) => {
			if (i === 0) {
				orientOptions.push(
					<option key="orient-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			orientOptions.push(
				<option key={`orient-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		let pcColumns = [
			{
				Header: 'Duplicate',
				accessor: ''
			},
			{
				Header: 'Delete',
				accessor: ''
			},
			{
				Header: 'Expected Ship Date',
				accessor: 'sched_ship_date'
			},
			{
				Header: 'PC Ship',
				accessor: 'ship_date'
			},
			{
				Header: 'PC Name',
				accessor: 'system_name'
			},
			{
				Header: 'Model',
				accessor: 'model'
			},
			{
				Header: 'Serial #',
				accessor: 'serial_number'
			},
			{
				Header: 'Care',
				accessor: 'care'
			},
			{
				Header: 'Start',
				accessor: 'start'
			},
			{
				Header: 'Expire',
				accessor: 'warranty_expire_date'
			},
			{
				Header: 'Fee',
				accessor: 'fee'
			},
			{
				Header: 'Description',
				accessor: 'description'
			},
			{
				Header: 'Update Type',
				accessor: 'updating_type'
			},
			{
				Header: 'TS Ver.',
				accessor: 'ts_admin_version'
			},
			{
				Header: 'Exit Method',
				accessor: 'exit_method'
			},
			{
				Header: 'Install Type',
				accessor: 'installation_type'
			},
			{
				Header: 'Orientation',
				accessor: 'orientation'
			},
			{
				Header: 'Sale Date',
				accessor: 'sale_date'
			},
			{
				Header: 'PC Trk #',
				accessor: 'tracking_number'
			},
			{
				Header: 'Wait To Ship',
				accessor: 'wait_to_ship'
			},
			{
				Header: 'PC Revenue',
				accessor: 'revenue'
			},
			{
				Header: 'Enclosure Finish',
				accessor: 'enclosure_finish'
			},
			{
				Header: 'Initial Warranty',
				accessor: 'initial_warr_period'
			},
			{
				Header: 'Enclosure Ship',
				accessor: 'encl_ship_date'
			},
			{
				Header: 'Enclosure Tracking',
				accessor: 'encl_tracking_number'
			},
			{
				Header: 'Reseller',
				accessor: 'reseller_flag'
			},
			{
				Header: 'Install Date',
				accessor: 'install_date'
			},
			{
				Header: 'Project ID',
				accessor: 'project'
			},
			{
				Header: 'PCDirID',
				accessor: 'pc_dir_id'
			}

		];

		let monitorColumns = [
			{
				Header: 'Duplicate',
				accessor: ''
			},
			{
				Header: 'Delete',
				accessor: ''
			},
			{
				Header: 'Monitor Ship',
				accessor: 'ship_date'
			},
			{
				Header: 'Model',
				accessor: 'model_id'
			},
			{
				Header: 'Serial #',
				accessor: 'serial_number'
			},
			{
				Header: 'Care',
				accessor: 'care'
			},
			{
				Header: 'Start',
				accessor: 'start'
			},
			{
				Header: 'Expire',
				accessor: 'expire'
			},
			{
				Header: 'Fee',
				accessor: 'fee'
			},
			{
				Header: 'Touch Type',
				accessor: 'usb_monitor'
			},
			{
				Header: 'Monitor Trk',
				accessor: 'tracking_number'
			},
			{
				Header: 'Description',
				accessor: 'description'
			},
			{
				Header: 'Initial Warranty',
				accessor: 'initial_warr_period'
			},
			{
				Header: 'Project ID',
				accessor: 'project'
			},
			{
				Header: 'MonDirID',
				accessor: 'mon_dir_id'
			}
		];

		let pcLength = routeData.pc ? routeData.pc.length : 0;
		let monitorLength = routeData.monitor ? routeData.monitor.length : 0;

		return (
			<Col xs={12} className="contentHardware program-other">
				<TabNavs
					title="HARDWARE"
					section={this.state.section}
					subsection={this.state.subsection}
					changeSubsection={this.changeSubsection}
				/>
				<Row className="lpad-row">
					<button
						className="warrantyInfo button btn"
						onClick={() => {
							let url = `${FORM_PREFIX}/warranty/?pid=${this.state.dbData.data.user.prop_num}`;
							window.open(url, '_blank');
						}}
					>
						Warranty
					</button>
					<button
						className="projSetup button btn"
						onClick={() => {
							let url = `${FORM_PREFIX}/project_setup/?pid=${this.state.dbData.data.user.prop_num}`;
							window.open(url, '_blank');
						}}
					>
						Project Setup
					</button>
					<Col xs={12} className="hardwareSection">
						<h4>PC Records: ({pcLength})</h4>
						{pcLength > 0 ? (
							<EditTable
								id="pc-hardware-edit-table"
								deleteSingleRecord={this.deleteSingleRecord}
								defaultPageSize={pcLength}
								data={routeData.pc}
								columns={pcColumns}
								showHardwareDuplication={this.state.showHardwareDuplication}
								setHardwareDuplicationModal={this.setHardwareDuplicationModal}
								triggerFormBoolChange={this.triggerFormBoolChange}
								triggerFormValueChange={this.triggerFormValueChange}
								triggerFormDateChange={this.triggerFormDateChange}
								triggerFormCurrencyChange={this.triggerFormCurrencyChange}
								updateDupTargetAndType={this.updateDupTargetAndType}
								parentTable="pc"
								routeData={routeData}
							/>
						) : (
								<div>
									<p>No PC Records for this property number</p>
								</div>
							)}
					</Col>
					<Col xs={8} className="hardwareSection">
						<h4>Monitor Records: ({monitorLength})</h4>
						{monitorLength > 0 ? (
							<EditTable
								id="monitor-hardware-edit-table"
								deleteSingleRecord={this.deleteSingleRecord}
								defaultPageSize={monitorLength}
								data={monitorLength > 0 ? routeData.monitor : []}
								columns={monitorColumns}
								showHardwareDuplication={this.state.showHardwareDuplication}
								setHardwareDuplicationModal={this.setHardwareDuplicationModal}
								triggerFormBoolChange={this.triggerFormBoolChange}
								triggerFormValueChange={this.triggerFormValueChange}
								triggerFormDateChange={this.triggerFormDateChange}
								triggerFormCurrencyChange={this.triggerFormCurrencyChange}
								updateDupTargetAndType={this.updateDupTargetAndType}
								parentTable="monitor"
								routeData={routeData}
							/>
						) : (
								<div>
									<p>No Monitor Records for this property number</p>
								</div>
							)}
					</Col>
					<Col xs={4} className="hardwareSection">
						<h4 className="pl-3">Notes:</h4>
						<FormTextArea
							dbView={this.state.dbView}
							humanLabel="Status Notes -- READ ONLY"
							label="installation_notes"
							value={routeData.customer.status_notes}
							parentID={routeData.customer.bronco.id_prefix}
							triggerFormValueChange={this.triggerFormValueChange}
							rows={20}
						/>
						<FormTextArea
							dbView={this.state.dbView}
							humanLabel="Tech Notes"
							label="tech_notes"
							value={routeData.customer.tech_notes}
							parentID={routeData.customer.bronco.id_prefix}
							triggerFormValueChange={this.triggerFormValueChange}
							rows={20}
						/>
					</Col>
				</Row>
			</Col>
		);
	}

	duplicateOnePC(targetPC) {
		return new Promise((resolve, reject) => {
			let authHeaders = this.md5PostXAuthHeaders();
			let dataObj = Object.assign({}, targetPC);

			dataObj.ID = 0;
			Reflect.deleteProperty(dataObj, 'CreatedAt');
			Reflect.deleteProperty(dataObj, 'UpdatedAt');
			Reflect.deleteProperty(dataObj, 'DeletedAt');

			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersPCs/`;

			let postObj = JSON.stringify(dataObj);

			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					console.log('ERROR in create PC');
					console.error(error);
					this.setState({
						error: `${error} -- Please check your network connection.`
					});
					return reject();
				})
				.then((res) => {
					return resolve(res);
				});
		});
	}

	duplicateOneMonitor(targetMonitor) {
		return new Promise((resolve, reject) => {
			let authHeaders = this.md5PostXAuthHeaders();
			let dataObj = Object.assign({}, targetMonitor);

			dataObj.ID = 0;
			Reflect.deleteProperty(dataObj, 'CreatedAt');
			Reflect.deleteProperty(dataObj, 'UpdatedAt');
			Reflect.deleteProperty(dataObj, 'DeletedAt');

			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersMonitors/`;

			let postObj = JSON.stringify(dataObj);

			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					console.log('ERROR in create PC');
					console.error(error);
					this.setState({
						error: `${error} -- Please check your network connection.`
					});
					return reject();
				})
				.then((res) => {
					return resolve(res);
				});
		});
	}

	createOnePC() {
		return new Promise((resolve, reject) => {
			let authHeaders = this.md5PostXAuthHeaders();
			let dataObj = {};
			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersPCs/`;

			dataObj.project = this.state.dbData.data.customer.project_id;
			let postObj = JSON.stringify(dataObj);
			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					console.log('ERROR in create PC');
					console.error(error);
					this.setState({
						error: `${error} -- Please check your network connection.`
					});
					return reject();
				})
				.then((res) => {
					return resolve(res);
				});
		});
	}

	createOneMonitor() {
		return new Promise((resolve, reject) => {
			let dataObj = {};
			let authHeaders = this.md5PostXAuthHeaders();
			const dataURL = `${
				API_PREFIX
				}/bronco/legacy/customersMonitors/`;
			dataObj.project = this.state.dbData.data.customer.project_id;
			let postObj = JSON.stringify(dataObj);
			fetch(dataURL, {
				body: postObj,
				method: 'POST',
				headers: Object.assign(
					{ 'content-type': 'application/json' },
					authHeaders
				)
			})
				.catch((error) => {
					console.log('ERROR in create Monitor');
					console.error(error);
					this.setState({
						error: `${error} -- Please check your network connection.`
					});
					return reject();
				})
				.then((res) => {
					return resolve(res);
				});
		});
	}

	buildNewOrderForm(routeData) {
		// const pcPrefix = `${routeData.pc[0].bronco.id_prefix}`;
		// const monPrefix = `${routeData.monitor[0].bronco.id_prefix}`;
		let pcModelOptions = [];
		let monModelOptions = [];
		let exOptions = [];
		let orientOptions = [];
		let updateOptions = [];
		let tsOptions = [];
		let installOptions = [];

		routeData.all_pc_model_types.forEach((option, i) => {
			if (i === 0) {
				pcModelOptions.push(
					<option key="pc-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			pcModelOptions.push(
				<option key={`pc-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_monitor_model_types.forEach((option, i) => {
			if (i === 0) {
				monModelOptions.push(
					<option key="mon-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			monModelOptions.push(
				<option key={`mon-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_update_types.forEach((option, i) => {
			if (i === 0) {
				updateOptions.push(
					<option key="update-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			updateOptions.push(
				<option key={`update-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_ts_admin_versions.forEach((option, i) => {
			if (i === 0) {
				tsOptions.push(
					<option key="ts-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			tsOptions.push(
				<option key={`ts-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_exit_methods.forEach((option, i) => {
			if (i === 0) {
				exOptions.push(
					<option key="exit-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			exOptions.push(
				<option key={`exit-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_installation_types.forEach((option, i) => {
			if (i === 0) {
				installOptions.push(
					<option key="install-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			installOptions.push(
				<option key={`install-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		routeData.all_orientations.forEach((option, i) => {
			if (i === 0) {
				orientOptions.push(
					<option key="orient-dropdown-0" value="0">
						No Selection
					</option>
				);
			}

			orientOptions.push(
				<option key={`orient-dropdown-${i + 1}`} value={option.id}>
					{option.value}
				</option>
			);
		});

		let pcColumns = [
			{
				Header: 'Duplicate',
				accessor: ''
			},
			{
				Header: 'Sale Date',
				accessor: 'sale_date'
			},
			{
				Header: 'PC Ship',
				accessor: 'ship_date'
			},
			{
				Header: 'PC Name',
				accessor: 'system_name'
			},
			{
				Header: 'Model',
				accessor: 'model'
			},
			{
				Header: 'Install Type',
				accessor: 'installation_type'
			},
			{
				Header: 'Orientation',
				accessor: 'orientation'
			},
			{
				Header: 'Description',
				accessor: 'description'
			},
			{
				Header: 'Update Type',
				accessor: 'updating_type'
			},
			{
				Header: 'TS Ver.',
				accessor: 'ts_admin_version'
			},
			{
				Header: 'PC Revenue',
				accessor: 'revenue'
			},
			{
				Header: 'Enclosure Finish',
				accessor: 'enclosure_finish'
			},
			{
				Header: 'Exit Method',
				accessor: 'exit_method'
			}
		];

		let monitorColumns = [
			{
				Header: 'Duplicate',
				accessor: ''
			},
			{
				Header: 'Monitor Ship',
				accessor: 'ship_date'
			},
			{
				Header: 'Model',
				accessor: 'model_id'
			},
			{
				Header: 'Initial Warranty',
				accessor: 'initial_warr_period'
			},
			{
				Header: 'Touch Type',
				accessor: 'usb_monitor'
			}
		];

		let fieldObj = {};
		let customerKeys = Object.keys(routeData.customer);
		customerKeys.forEach((key, i) => {
			switch (key) {
				case 'ship_address':
				case 'custom_vinyl_desc':
				case 'installation_notes':
				case 'other_equip':
					fieldObj[key] = (
						<FormTextArea
							colsize={12}
							key={`${i}-newOrder-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							value={routeData.customer[key]}
							parentID={routeData.customer.bronco.id_prefix}
							triggerFormValueChange={this.triggerFormValueChange}
							rows={10}
						/>
					);
					break;
				case 'custom_vinyl':
					fieldObj[key] = (
						<FormSelect
							colsize={12}
							key={`${i}-newOrder-cust`}
							dbView={this.state.dbView}
							humanLabel={this.makeLabel(key)}
							label={key}
							valueArray={routeData.all_custom_vinyl}
							currentValue={routeData.customer[key]}
							triggerFormValueChange={this.triggerFormValueChange}
							parentID={routeData.customer.bronco.id_prefix}
							rows={10}
						/>
					);
					break;
				default:
			}
		});

		fieldObj.archive = (
			<FormBool
				colsize={7}
				key="newOrder-cont"
				dbView={this.state.dbView}
				humanLabel="Archive"
				label="archive"
				value={routeData.user.archive}
				triggerFormValueChange={this.triggerFormValueChange}
				triggerFormBoolChange={this.triggerFormBoolChange}
				parentID={routeData.user.bronco.id_prefix}
			/>
		);

		let fieldArray = [];
		fieldArray.push(
			fieldObj.archive,
			fieldObj.ship_address,
			fieldObj.installation_notes,
			fieldObj.other_equip,
			fieldObj.custom_vinyl,
			fieldObj.custom_vinyl_desc
		);

		let pcLength = routeData.pc ? routeData.pc.length : 0;
		let monitorLength = routeData.monitor ? routeData.monitor.length : 0;

		let newPCElm = (
			<Button
				className="miniAddBtn button"
				onClick={() => {
					if (this.state.formChanged) {
						window.alert('Please save changes before creating new records.');
						return;
					}
					this.togglePCBatch();
				}}
			>
				+
			</Button>
		);

		if (this.state.showPCBatch) {
			newPCElm = (
				<BatchUploader
					batchFunc={this.createOnePC}
					inputID="pc-batch-upload"
					inputName="pc-batch"
					show={this.state.showPCBatch}
					toggle={this.togglePCBatch}
					loader={this.toggleLoader}
					modalToggle={false}
					resetPage={() => {
						return this.batchReset(this.state.section, this.state.subsection, this.state.route);
					}}
					reportErr={this.reportErr}
				/>
			);
		}

		let newMonitorElm = (
			<Button
				className="miniAddBtn button"
				onClick={() => {
					if (this.state.formChanged) {
						window.alert('Please save changes before creating new records.');
						return;
					}
					this.toggleMonitorBatch();
				}}
			>
				+
			</Button>
		);

		if (this.state.showMonitorBatch) {
			newMonitorElm = (
				<BatchUploader
					batchFunc={this.createOneMonitor}
					inputID="monitor-batch-upload"
					inputName="monitor-batch"
					show={this.state.showMonitorBatch}
					toggle={this.toggleMonitorBatch}
					loader={this.toggleLoader}
					modalToggle={false}
					resetPage={() => {
						return this.batchReset(this.state.section, this.state.subsection, this.state.route);
					}}
					reportErr={this.reportErr}
				/>
			);
		}

		let dupModal = this.makeDupModal();
		return (
			<Col xs={12} className="contentHardware program-other">
				<TabNavs
					title="HARDWARE"
					section={this.state.section}
					subsection={this.state.subsection}
					changeSubsection={this.changeSubsection}
				/>
				<Row className="lpad-row">
					<Col xs={9}>
						<Row>
							<Col xs={12} className="hardwareSection">
								<h4 id="PC-ENCLOSURE-HEADER">
									PC / ENCLOSURE {' '} {newPCElm}
								</h4>
								{pcLength > 0 ? (
									<EditTable
										id="pc-new-order-edit-table"
										columns={pcColumns}
										data={routeData.pc}
										defaultPageSize={pcLength}
										parentTable="pc"
										routeData={routeData}
										showHardwareDuplication={this.state.showHardwareDuplication}
										setHardwareDuplicationModal={this.setHardwareDuplicationModal}
										triggerFormBoolChange={this.triggerFormBoolChange}
										triggerFormCurrencyChange={this.triggerFormCurrencyChange}
										triggerFormDateChange={this.triggerFormDateChange}
										triggerFormValueChange={this.triggerFormValueChange}
										updateDupTargetAndType={this.updateDupTargetAndType}
									/>
								) : (
										<div>
											<p>No PC Records for this property number</p>
										</div>
									)}

								{dupModal}
							</Col>
							<Col xs={6} className="hardwareSection">
								<h4>
									Monitor {' '} {newMonitorElm}
								</h4>
								{monitorLength > 0 ? (
									<EditTable
										id="monitor-new-order-edit-table"
										defaultPageSize={monitorLength}
										data={monitorLength > 0 ? routeData.monitor : []}
										columns={monitorColumns}
										showHardwareDuplication={this.state.showHardwareDuplication}
										setHardwareDuplicationModal={this.setHardwareDuplicationModal}
										triggerFormBoolChange={this.triggerFormBoolChange}
										triggerFormValueChange={this.triggerFormValueChange}
										triggerFormDateChange={this.triggerFormDateChange}
										triggerFormCurrencyChange={this.triggerFormCurrencyChange}
										updateDupTargetAndType={this.updateDupTargetAndType}
										parentTable="monitor"
										routeData={routeData}
									/>
								) : (
										<div>
											<p>No Monitor Records for this property number</p>
										</div>
									)}
							</Col>
							<Col xs={6}>
								<h4 className="pl-3">Notes:</h4>
								<FormTextArea
									colsize={12}
									dbView={this.state.dbView}
									humanLabel="Status Notes"
									label="installation_notes"
									value={routeData.customer.status_notes}
									parentID={routeData.customer.bronco.id_prefix}
									triggerFormValueChange={this.triggerFormValueChange}
									rows={20}
								/>
								<FormTextArea
									colsize={12}
									dbView={this.state.dbView}
									humanLabel="Tech Notes"
									label="tech_notes"
									value={routeData.customer.tech_notes}
									parentID={routeData.customer.bronco.id_prefix}
									triggerFormValueChange={this.triggerFormValueChange}
									rows={20}
								/>
							</Col>
						</Row>
					</Col>
					<Col xs={3}>{fieldArray}</Col>
				</Row>
			</Col>
		);
	}

	buildPurchaseOrderForm(routeData) {
		let forms = [];
		if (
			this.isBetterArray(routeData.purchase_order) &&
			routeData.purchase_order.length > 0
		) {
			routeData.purchase_order.forEach((po, i) => {
				let poKeys = Object.keys(po);
				let formObj = {};
				let sec1 = [];
				let sec2 = [];
				let sec3 = [];
				let sec4 = [];
				let sec5 = [];
				let sec6 = [];
				poKeys.forEach((key, j) => {
					switch (key) {
						case 'id':
						case 'ID':
						case 'bronco':
						case 'access_id':
						case 'CreatedAt':
						case 'UpdatedAt':
						case 'DeletedAt':
							break;
						case 'date_needed':
						case 'date_entered':
						case 'date_approved':
						case 'outfor_approval':
						case 'date_complete':
							formObj[key] = (
								<FormDatePicker
									colsize={6}
									key={`${po.bronco.id_prefix}-${j}`}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									date={po[key]}
									triggerFormDateChange={this.triggerFormDateChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'completed':
						case 'crate_needed':
						case 'crate_complete':
						case 'received':
							formObj[key] = (
								<FormBool
									colsize={4}
									key={`${po.bronco.id_prefix}-${j}`}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									value={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									triggerFormBoolChange={this.triggerFormBoolChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'product':
							formObj[key] = (
								<FormSelect
									colsize={12}
									key={`${po.bronco.id_prefix}-${j}`}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									valueArray={routeData.all_model_types}
									currentValue={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'touch_system':
							formObj[key] = (
								<FormSelect
									colsize={12}
									key={`${po.bronco.id_prefix}-${j}`}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									valueArray={routeData.all_touch_systems}
									currentValue={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'vendor':
							formObj[key] = (
								<FormSelect
									colsize={6}
									key={`${po.bronco.id_prefix}-${j}`}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									valueArray={routeData.all_vendors}
									currentValue={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'enc_type':
							formObj[key] = (
								<FormSelect
									colsize={12}
									key={`${po.bronco.id_prefix}-${j}`}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									valueArray={routeData.all_enclosure_types}
									currentValue={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'enc_notes':
						case 'back_box_notes':
						case 'face_notes':
						case 'lettering':
						case 'components':
						case 'special_instructions':
							formObj[key] = (
								<FormTextArea
									key={`${po.bronco.id_prefix}-${j}`}
									colsize={12}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									value={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'back_box_width':
						case 'back_box_depth':
						case 'back_box_height':
						case 'face_width':
						case 'face_height':
						case 'face_depth':
							formObj[key] = (
								<FormText
									key={`${po.bronco.id_prefix}-${j}`}
									colsize={4}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									value={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'ven_job_num':
						case 'quantity':
							formObj[key] = (
								<FormText
									key={`${po.bronco.id_prefix}-${j}`}
									colsize={6}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									value={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						case 'cost':
							formObj[key] = (
								<FormCurrency
									key={`${po.bronco.id_prefix}-${j}`}
									colsize={6}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									value={po[key]}
									triggerFormCurrencyChange={this.triggerFormCurrencyChange}
									parentID={po.bronco.id_prefix}
								/>
							);
							break;
						default:
							formObj[key] = (
								<FormText
									key={`${po.bronco.id_prefix}-${j}`}
									colsize={12}
									dbView={this.state.dbView}
									humanLabel={this.makeLabel(key)}
									label={key}
									value={po[key]}
									triggerFormValueChange={this.triggerFormValueChange}
									parentID={po.bronco.id_prefix}
								/>
							);
					}
				});

				formObj.spacer = (
					<div className="col-6"></div>
				);

				sec1.push(
					// formObj.client_reference,
					formObj.client_ref_2,
					formObj.dsponum,
					formObj.product,
					formObj.quantity,
					formObj.cost,
					formObj.vendor,
					formObj.ven_job_num,
					formObj.enc_type,
					formObj.enc_notes
				);

				sec2.push(
					formObj.back_box_width,
					formObj.back_box_height,
					formObj.back_box_depth,
					formObj.back_box_notes
				);

				sec3.push(
					formObj.face_width,
					formObj.face_height,
					formObj.face_depth,
					formObj.face_notes,
					formObj.finish
				);

				sec4.push(formObj.lettering, formObj.letter_type, formObj.letter_color);

				sec5.push(formObj.touch_system, formObj.components);

				sec6.push(
					formObj.special_instructions,
					formObj.date_needed,
					formObj.outfor_approval,
					formObj.date_approved,
					formObj.spacer,
					formObj.crate_needed,
					formObj.crate_complete,
					formObj.received,
					formObj.image_name,
					formObj.date_complete,
					formObj.completed
				);

				let col1 = [];
				let col2 = [];
				col1.push(
					<FormSection title="PURCHASE ORDER" fields={sec1} />,
					<FormSection title="BACK BOX" fields={sec2} />
				);

				col2.push(
					<FormSection title="FACE / COVER" fields={sec3} />,
					<FormSection title="LETTERING" fields={sec4} />,
					<FormSection title="COMPONENTS" fields={sec5} />
				);

				let col3 = <FormSection title="STATE / SPECIAL" fields={sec6} />;
				let displayDate = moment(po.date_entered).format('MMMM DD, YYYY');
				forms.push(
					<POForm
						formChanged={this.state.formChanged}
						deleteSingleRecord={this.deleteSingleRecord}
						recordID={po.ID}
						title={displayDate}
						section1={col1}
						section2={col2}
						section3={col3}
					/>
				);
			});
		} else {
			forms.push(
				<Col xs={12} key="no-pos">
					<p>There are no purchase order records for this property</p>
				</Col>
			);
		}

		return (
			<Col xs={12} className="contentHardware program-other">
				<TabNavs
					title="HARDWARE"
					section={this.state.section}
					subsection={this.state.subsection}
					changeSubsection={this.changeSubsection}
				/>
				<Button
					color="success"
					className="newPO"
					onClick={() => {
						if (this.state.formChanged) {
							return window.alert('Please save changes before creating new records');
						}

						if (window.confirm('Create New Purchase Order?')) {
							let dataObj = {};
							let authHeaders = this.md5PostXAuthHeaders();
							const dataURL = `${
								API_PREFIX
								}/bronco/legacy/customersPurchaseOrders/`;

							dataObj.client_reference = this.state.dbData.data.customer.project_id;

							let plainDate = moment();
							let fmtDate = plainDate.format('ddd MMM DD HH:mm:ss UTC YYYY');
							dataObj.date_entered = fmtDate;

							let postObj = JSON.stringify(dataObj);

							fetch(dataURL, {
								body: postObj,
								method: 'POST',
								headers: Object.assign(
									{ 'content-type': 'application/json' },
									authHeaders
								)
							})
								.catch((error) => {
									return this.setState({
										error: `${error} -- Please check your network connection.`
									});
								})
								.then((res) => {
									this.handleGetRouteFromSearch(this.state.route, () => {
										this.setState({
											section: 'HARDWARE',
											subsection: 'POS'
										});
									});
								});
						}
					}}
				>
					New PO
				</Button>
				<Row className="lpad-row">{forms}</Row>
			</Col>
		);
	}

	buildServiceCallForm() {
		let singleRecord = [];

		let qrsProps = {
			activeID: this.state.activeSvc,
			activeIDKey: 'activeSvc',
			activeType: this.state.activeSvcType,
			activeTypeKey: 'activeSvcType',
			buildRecordForm: this.buildSvcRecordForm,
			buildQuoteForm: this.buildSvcQuoteForm,
			newRecord: this.newSvcRecord,
			newQuote: this.newSvcQuote,
			mixedArray: this.state.serviceRecords,
			flavor: 'service',
			setNewActiveRecord: this.changeActiveItem
		};

		let svcElm = QuoteRecordSelector(qrsProps);
		singleRecord.push(svcElm);

		return (
			<Col xs={12} className="contentHardware program-other">
				<TabNavs
					title="HARDWARE"
					section={this.state.section}
					subsection={this.state.subsection}
					changeSubsection={this.changeSubsection}
				/>
				{singleRecord}
			</Col>
		);
	}
}

window.addEventListener('beforeunload', function (e) {
	e.preventDefault();
	let confirmationMessage = 'If you leave before saving, your changes will be lost.';
	// (e || window.event).returnValue = confirmationMessage; //Gecko + IE
	e.returnValue = confirmationMessage; //Gecko + IE
	return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
});

export default App;



// WEBPACK FOOTER //
// ./src/App.js